import React, { forwardRef, useState, useEffect, useLayoutEffect, useRef, useMemo, useCallback, lazy, Suspense } from 'react';

import { translateText, translateStrict } from '../services/translate';
import { encryptMessage, encryptFile, encryptGroupFile, decryptMessage, decryptFile,  getE2EEReady } from '../services/signalSession';
import { signalStore, getCachedDecryption, setCachedDecryption, cacheKeyOf} from '../services/signalStore';
import { encryptGroupMessage, decryptGroupMessage, unwrapGroupKey, decryptDiscussionFields, wrapGroupKeyForParticipant, requestSessionReset } from '../services/signalGroupCrypto';
import { aesEncryptBytes } from '../services/signalCrypto';
import { requestHistoryRepair, applyReadyBatches, healSignalError } from '../services/historyRepair';
import { decryptOne, decryptBatch } from '../services/messageDecrypt';

import E2EEImage from './E2EEImage';
import E2EEVideo from './E2EEVideo';
import E2EEAudio from './E2EEAudio';

import io from 'socket.io-client';
import axios from 'axios';
import ReactPlayer from 'react-player/youtube';

import { jwtDecode } from 'jwt-decode';
import UserList from './UserList';
import ParticipantsList from './ParticipantsList';
import VideoCall from './VideoCall';
import VideoPreview from './VideoPreview';
import WaveCanvas from './WaveCanvas';
import { AmbianceRenderer } from './AmbianceRenderer';
import YouTubeEmbed from './YouTubeEmbed';
import TranslationBadge  from './TranslationBadge';
import E2EETranslation  from './E2EETranslation';


import { useNavigate } from 'react-router-dom';

import crypto from 'crypto-browserify';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/styles.css";


import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';

import api from '../services/api';
//import {requestContactsAccess} from '../services/requestContactsAccess';
import { useContactsPermission } from '../services/requestContactsAccess';

//import { motion } from "framer-motion";
import { FaThumbsUp } from 'react-icons/fa';
import EmojiPicker from 'emoji-picker-react';

import MessageParser from './MessageParser';
import { format } from "date-fns";
import { fr } from "date-fns/locale"; 
import CommentSection from './CommentSection';
import BirthdayCardModal from './BirthdayCardModal';
import NewYearCardModal from './NewYearCardModal';

import LoveCardModal from './LoveCardModal';
import  AmbianceCardModal  from './AmbianceCardModal';
import { AMBIANCE_SOUNDS } from '../utils/ambianceTemplates';
import { AMBIANCE_IMAGES } from '../utils/ambianceTemplates';

import {
  formatTime, formatDate, formaterDate, isToday, 
  extractYouTubeUrl, getMimeType, getExtensionFromMime, generateParticles,
  DOC_LABELS, DOCUMENT_FIELD_BY_MIME, resolveFileField
} from '../utils/discussionUtils';

import { useAmbiance, useAmbianceConfig } from '../hooks/useAmbiance';
import Whiteboard from './Whiteboard';
import WhiteboardToolbar from './WhiteboardToolbar';
import VoiceCommands from "./VoiceCommands";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import Agenda from "./Agenda";
import EventModal from "./EventModal";
import EditDiscussionModal from './EditDiscussionModal';
import DiscussionPanels from './Panels';
import ModalAutoDelete from './ModalAutoDelete';

//styles du panneau files
const btnStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
  background: 'rgba(128,128,128,0.1)',
  border: '1px solid rgba(128,128,128,0.15)',
  borderRadius: '10px',
  padding: '10px 4px 8px',
  cursor: 'pointer',
  minHeight: '60px',     // cible tactile confortable
  color: 'var(--input-color)',
};

const btnStyleBottom = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2px',
  background: 'none',
  border: 'none',
  borderRadius: '10px',
  padding: '2px 2px 2px',
  cursor: 'pointer',

  color: 'var(--input-color)',
};

const btnWideStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
  background: 'rgba(128,128,128,0.1)',
  border: '1px solid rgba(128,128,128,0.15)',
  borderRadius: '10px',
  padding: '10px 14px',
  cursor: 'pointer',
  minHeight: '48px',
  color: 'var(--input-color)',
};

const iconStyle = {
  fontSize: '22px',
  lineHeight: 1,
};

const labelStyle = {
  fontSize: '10px',
  color: 'var(--input-color)',
  opacity: 0.7,
  textAlign: 'center',
  lineHeight: 1.2,
};

const labelWideStyle = {
  fontSize: '12px',
  color: 'var(--input-color)',
  opacity: 0.8,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

const badgeStyle = {
  fontSize: '9px',
  background: 'rgba(55,138,221,0.15)',
  color: '#378ADD',
  borderRadius: '4px',
  padding: '1px 5px',
  fontWeight: '500',
};

//styles du panneau utils

const utilsBtnStyle = {
  background: 'none',
  border: '1px solid var(--input-color)',
  borderRadius: '10px',
  padding: '10px',
  cursor: 'pointer',
  color: 'var(--input-color)',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const iconBlueStyle = {
  fontSize: '18px',
  color: '#007bff',
};

const iconRedStyle = {
  fontSize: '18px',
  color: 'red',
};

const iconGrayStyle = {
  fontSize: '18px',
  color: '#666',
};
const iconFileStyle = {
  fontSize: '22px',
  color: 'var(--text-color)',
};
const iconEraserStyle = {
  fontSize: '20px',
  color: '#007bff',
};



// Composant pour envoyer des messages


const SendMessage = forwardRef(({ discussionId, userObj, socket, prompt, isPublic, creatorId, confidentialReply, onClearConfidentialReply, onNewMessage, onMessageSent, participants, showParticipantsList, setShowParticipantsList, showUserList, setShowUserList, showSearch, setShowSearch, handleLeaveDiscussionPrivate, handleInviteUser, isCreator, discussion, handleDeleteDiscussion, setSelectedDiscussion, selectedDiscussion, onEdit, discussionName, description, openAgenda, setOpenAgenda, highlightEventId, setHighlightEventId, startVideoCall, handleInviteClick, replyTo, setReplyTo, utilsBarHeight = 0, showUtilsPanelBottom, setShowUtilsPanelBottom, autoDeleteAfter, setAutoDeleteAfter, recipientId_new, waitingForParticipant, otherParticipantIds, currentParticipants }, ref) => {

const [showAutoDeleteModal, setShowAutoDeleteModal] = useState(false);
const [discussionTitle, setDiscussionTitle] = useState('');
const [decryptedDescription, setDecryptedDescription] = useState('');
  const [messages, setMessages] = useState('');
const [message, setMessage] = useState('');
  const [image, setImage] = useState(null);
 const [currentUserId, setCurrentUserId] = useState(null);
const [setDiscussion] = useState([]); 
const [currentUser, setCurrentUser] = useState(null);

const shouldScrollRef = useRef(false);
   const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
const isSendingRef = useRef(false);

const [file, setFile] = useState(null);
const [fileType, setFileType] = useState('');
const [recording, setRecording] = useState(false);
const mediaRecorderRef = useRef(null);
const audioChunksRef = useRef([]);
const [audioBlob, setAudioBlob] = useState(null);
const audioInputRef = useRef(null);
const audioInputRef_record = useRef(null);
const [recordingSeconds, setRecordingSeconds] = useState(0);
const timerRef = useRef(null);

const ambiances = useAmbianceConfig();
const { soundOn, setSoundOn, playAmbianceSound, stopAmbianceSound } = useAmbiance();

const recordedChunksRef = useRef([]);
const [isRecording, setIsRecording] = useState(false);
const [audioReady, setAudioReady] = useState(false);
const [videoReady, setVideoReady] = useState(false);
const [imageReady, setImageReady] = useState(false);
const [videofileReady, setVideofileReady] = useState(false);
const [audiofileReady, setAudiofileReady] = useState(false);
const [docReady, setDocReady] = useState(false);
const [isModerating, setIsModerating] = useState(false);
const [someoneTyping, setSomeoneTyping] = useState(false);

const recorderRef = useRef(null);
const [isFileReady, setIsFileReady] = useState(false);
const pdfInputRef = useRef(null);
const [fcmToken, setFcmToken] = useState(null);


const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const { t } = useTranslation();
const myLang = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];


const [particlePositionsMap, setParticlePositionsMap] = useState({});


const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);



// demande d'autorisation pour ouvrir la caméra
// Parent — un seul handler
const handleCameraClick = async () => {
  if (window.cordova) {
    const permissions = window.cordova.plugins?.permissions;
    if (permissions) {
      await new Promise((resolve, reject) => {
        permissions.checkPermission(
          permissions.CAMERA,
          (status) => status.hasPermission ? resolve() : 
            permissions.requestPermission(permissions.CAMERA,
              (result) => result.hasPermission ? resolve() : reject(),
              () => reject()
            ),
          () => reject()
        );
      })
      .then(() => imageInputRef.current?.click())
      .catch(() => console.warn('Permission caméra refusée'));
      return;
    }
  }
  imageInputRef.current?.click();
};

// Fonction pour ouvrir le sélecteur de fichiers
  const handleIconClick = async (type) => {
const { alert, confirm } = prompt;
    if (type === "image" && imageInputRef.current) {
setImageReady(false);
      imageInputRef.current.click();
	} 
 else if (type === "video" && videoInputRef.current) {
setVideofileReady(false);
videoInputRef.current?.click();
}
else if (type === "video-record") {
setShowFilePanel(false);
          try {
    const recordedVideo = await handleCaptureVideo(); //⬅️ même pattern que audio
setFile(recordedVideo); // pour prévisualisation
    if (!recordedVideo) {
     
      return;
    }

    
    await handleSendMessage(recordedVideo);
setVideoReady(false); 
    setFile(null); // reset

  } catch (err) {
    console.error('🎥 Erreur capture vidéo :', err);
    alert("Impossible de capturer la vidéo.");
  }
     
    	} else if (type === "audio-existing" && audioInputRef.current) {
setAudiofileReady(false);

    audioInputRef.current.click(); // pour fichier existant
  	} else if (type === "audio-record") {
setShowFilePanel(false);
     try {
      const recordedFile = await handleRecordAudio(); // File ou Blob
setFile(recordedFile);
      if (!recordedFile) {
     
        return;
      }
      await handleSendMessage(recordedFile); // ← on passe le fichier directement
setAudioReady(false);                  // faire disparaître le message

  setFile(null);  
    } catch (err) {
      console.error('Erreur enregistrement audio :', err);
      alert('Impossible d’enregistrer l’audio.');
    }

  	} else if (type === "pdf" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
	} else if (type === "ppt" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
	} else if (type === "pptx" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
} else if (type === "odp" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
} else if (type === "xls" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
} else if (type === "xlsx" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
} else if (type === "ods" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();

	} else if (type === "odt" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
	} else if (type === "txt" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();
	} else if (type === "doc" && pdfInputRef.current) {
setDocReady(false);
      pdfInputRef.current.click();



	}else {
await alert(t('discussion.incorrectfile'));
        return;

console.error('Format de fichier non pris en charge');

}
 
 };

const handleCaptureVideo = async () => {
  try {
    const recordedVideo = await new Promise((resolve, reject) => {
      navigator.device.capture.captureVideo(
        (mediaFiles) => {
          const mediaFile = mediaFiles[0];
          window.resolveLocalFileSystemURL(
            mediaFile.fullPath,
            (fileEntry) => {
              fileEntry.file((file) => {
                resolve(file);
              }, reject);
            },
            reject
          );
        },
        reject,
        { limit: 1, duration: 30 }
      );
    });
setVideoReady(false); 
    if (!recordedVideo) throw new Error("Vidéo non capturée");

    const reader = new FileReader();
    reader.onloadend = () => {
      const blob = new Blob([reader.result], { type: 'video/mp4' });


      let finalFile;
      try {
        finalFile = new File([blob], 'recorded-video.mp4', {

          type: 'video/mp4',

          lastModified: Date.now()
        });
      } catch {
        finalFile = blob;
        finalFile.name = 'recorded-video.mp4';
        finalFile.type = 'video/mp4';
      }
setVideoReady(true); 
      // ⬇️ Appel clair ici
      handleFileChange({ target: { files: [blob] } });
    };

    reader.readAsArrayBuffer(recordedVideo);
  } catch (err) {
    console.error('🎥 Erreur enregistrement vidéo :', err);
    alert("Impossible d'enregistrer la vidéo.");
  }
};


const startRecording = async () => {

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    recordedChunksRef.current = [];

    const mediaRecorder = new MediaRecorder(stream, { mimeType: 'audio/webm' });
    mediaRecorderRef.current = mediaRecorder;

    mediaRecorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        recordedChunksRef.current.push(event.data);
      }
    };

    mediaRecorder.onstop = () => {
      const blob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });

      if (blob.size === 0) {
        alert("⚠️ Enregistrement vide. Réessayez.");
        return;
      }

      const file = new File([blob], 'recorded-audio.webm', {
        type: 'audio/webm',
        lastModified: Date.now(),
      });



      // Appelle logique de fichier
      handleFileChange({ target: { files: [file] } });

      setRecording(false);
    };

    mediaRecorder.start();
    setRecording(true);

  } catch (error) {
    console.error("Erreur d'accès au micro :", error);
    alert("Impossible de démarrer l'enregistrement audio.");
  }
};

const stopRecording = () => {
  const recorder = mediaRecorderRef.current;

  if (recorder && recorder.state === 'recording') {
    recorder.stop();
    
  } else {
    alert("Aucun enregistrement en cours.");
  }
};

// Gestion de la sélection des fichiers
 
const handleFileChange = async (e) => {
const { alert } = prompt;


setImageReady(false);
setVideofileReady(false);
setAudiofileReady(false);
setDocReady(false);
setShowFilePanel(false);

  const selectedFile = e?.target?.files?.[0];
  if (!selectedFile) return;


// ✅ Vérification taille ici, avant tout traitement
const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 Mo
if (selectedFile.size > MAX_FILE_SIZE) {
  alert(t('discussion.fileTooLarge'));
  e.target.value = ''; // 🔧 reset l'input file pour permettre une nouvelle sélection
  return;
}

  // 🔧 Fallback pour `name` si absent (ex. Blob sous Android Cordova)
  if (typeof selectedFile.name !== 'string') {
    selectedFile.name = 'media-file';
  }

// 🔧 Normalisation des types MIME non-standard
const mimeNormalization = {
  'video/x-matroska': 'video/x-matroska', // accepté tel quel
  'video/x-msvideo': 'video/avi',
  'video/quicktime': 'video/quicktime',
 
};
  // 🔧 Table de correspondance extension → type MIME
  // ✅ Liste blanche des types acceptés
const ACCEPTED_TYPES = [
  'image/png', 'image/jpeg', 'image/gif', 'image/webp',
  'video/mp4', 'video/webm', 'video/mpeg', 'video/quicktime', 'video/x-matroska',
  'audio/mpeg', 'audio/wav', 'audio/webm', 'audio/mp4', 'audio/ogg',
  'application/pdf', 'text/plain', 'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
];

if (!ACCEPTED_TYPES.includes(selectedFile.type)) {
  console.error('❌ Type MIME non accepté :', selectedFile.type);
 await alert(t('discussion.incorrectfile'));
  return;
}
//const selectedFile = e?.target?.files?.[0];
// 🕵️ Correction du type si nécessaire
// 🔁 Mapping extension → MIME
  const extensionToMime = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    mp4: 'video/mp4',
    webm: 'video/webm',
    mpeg: 'video/mpeg',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    pdf: 'application/pdf',
    txt: 'text/plain',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    odt: 'application/vnd.oasis.opendocument.text',
    ods: 'application/vnd.oasis.opendocument.spreadsheet',
    odp: 'application/vnd.oasis.opendocument.presentation',
  };
  if (typeof selectedFile.type !== 'string' || !selectedFile.type.includes('/')) {

    const extension = selectedFile.name.split('.').pop().toLowerCase();
    let guessedMime = extensionToMime[extension];
    // Petit hack pour différencier audio webm / vidéo webm si besoin
    if (extension === 'webm' && selectedFile.size > 1000000) {
      guessedMime = 'video/webm';
    }

  
    
  }

  
  // 🎯 Mise à jour des états

  setFileType(selectedFile.type);
  setFile(selectedFile);

     if (selectedFile.type.startsWith('image/')) {
    setImageReady(true);

  } else if (selectedFile.type.startsWith('video/')) {

     setVideofileReady(true);
	setVideoReady(false);

  } else if (selectedFile.type.startsWith('audio/')) {
    setAudiofileReady(true);
	setAudioReady(false);

  } else  {
     setDocReady(true);
}


};


// audio enregistré
const handleRecordAudio = async (resolve, reject) => {
  try {
    // Permission Cordova si nécessaire
    if (window.cordova && cordova.plugins?.permissions) {
      const { permissions } = cordova.plugins;
      await new Promise((resolve, reject) => {
        permissions.checkPermission(permissions.RECORD_AUDIO, (status) => {
          if (status.hasPermission) return resolve();
          permissions.requestPermission(permissions.RECORD_AUDIO, (res) => {
            res.hasPermission ? resolve() : reject();
          }, reject);
        }, reject);
      });
    }
setRecordingSeconds(0);
timerRef.current = setInterval(() => setRecordingSeconds(s => s + 1), 1000);

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    mediaRecorderRef.current = recorder;
    audioChunksRef.current = [];
recorderRef.current = recorder;
setIsRecording(true);       // ✅ Enregistrement en cours
setAudioReady(false);       // 🛑 Pas encore prêt
setImageReady(false); 
setVideofileReady(false); 
setAudiofileReady(false); 
setDocReady(false); 
setIsModerating(false); 
    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) audioChunksRef.current.push(e.data);
    };

    recorder.onstop = () => {
      stream.getTracks().forEach(t => t.stop());
clearInterval(timerRef.current);
      const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

      let recordedFile;
try {
  recordedFile = new File([blob], 'recorded-audio.webm', { type: 'audio/webm' });
} catch {
  recordedFile = blob;
  recordedFile.name = 'recorded-audio.webm';
  recordedFile.type = 'audio/webm';
}
setIsRecording(false);     // ✅ Fin d’enregistrement
setAudioReady(true);       // ✅ Audio prêt à envoyer


      handleFileChange({ target: { files: [blob] } });

 

    };

    recorder.start();
    setRecording(true);

    

  } catch (err) {
reject(err);
setIsRecording(false);
    console.error("🎙️ Erreur d'enregistrement audio :", err);
    alert("Impossible d'enregistrer l'audio.");
  }
};

useEffect(() => {
    // Récupérer l'ID de l'utilisateur à partir du token
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setCurrentUserId(decodedToken.id); // Stocker l'ID de l'utilisateur actuel
    }
  }, []);


useEffect(() => {
  if (!socket || !currentUserId) return;

  // S'enregistrer côté serveur
  socket.emit('register', { userId: currentUserId });

}, [socket, currentUserId]);

//fonction de typing
const typingTimeout = useRef(null);

const handleTyping = (e) => {
  setMessage(e.target.value);
  socket.emit("typing", { userId: currentUserId, isTyping: true, discussionId });

  clearTimeout(typingTimeout.current);
  typingTimeout.current = setTimeout(() => {
    socket.emit("typing", { userId: currentUserId, isTyping: false, discussionId });
  }, 2000);
};

//AMBIANCES
 const [selectedAmbiance, setSelectedAmbiance] = useState(null);


const [selected, setSelected] = useState(null);
const audioCtxRef = useRef(null);
const nodesRef = useRef({});
const intervalsRef = useRef([]);


useEffect(() => {
    if (socket && currentUser) {
      socket.emit("register", {
        userId: currentUser._id,
        username: currentUser.username,
        profileImage: currentUser.profileImage,
profileImageUpdatedAt: currentUser.profileImageUpdatedAt
      });
    }

  }, [socket, currentUser]);

async function checkModeration(blob, originalName, mimeType) {
  const formData = new FormData();
  formData.append('file', blob, originalName);

  const token = localStorage.getItem('token');
  const response = await api.post(`${API_URL}/api/moderation/check-file`, formData, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data.accepted;
}


const handleSendMessage = async (e, externalFile = null, externalMessage = null) => {

  if (e) e.preventDefault();
  if (isSendingRef.current) return;                       // anti double-envoi

  const { alert, confirm } = prompt;
  const fileToSend = externalFile || file;
  const messageToSend = externalMessage !== null ? externalMessage : message;

  if (!messageToSend && !fileToSend) {
    await alert(t('discussion.alertempty'));
    return;
  }

if (waitingForParticipant && !confidentialReply) {
  await alert(t('discussion.en_attente_participant'));
  return;
}

  // ---- Mode de chiffrement : calculé UNE fois ----
  
const isGroup = otherParticipantIds.length > 1;
//const isGroup = Array.isArray(discussion?.participants) && discussion.participants.length > 2;
const otherIds = otherParticipantIds;
//const otherIds = (discussion?.participants || [])
//  .map(p => String(p?._id || p))
//  .filter(id => id !== String(currentUserId));

let plainOk = false;

if (!discussion?.isPublic && otherIds.length) {
  let readySet;
  try {
    readySet = await getE2EEReady(otherIds);
  } catch {
    await alert(t('discussion.erreurenvoi'));   // service injoignable : on ne bascule PAS en clair
    return;
  }
  const legacyIds = otherIds.filter(id => !readySet.has(id));

  if (legacyIds.length) {
    if (confidentialReply) {                    // un message confidentiel exige l'E2EE
      await alert(t('discussion.confidentiel_impossible'));
      return;
    }
    for (const id of legacyIds) {               // anti-downgrade
      if (await signalStore.get(`peerE2EE_${id}`)) {
        await alert(t('discussion.e2ee_perdue'));
        return;
      }
    }
    plainOk = await confirm(t('discussion.envoi_non_chiffre'));
    if (!plainOk) return;
  }
}

const mode = plainOk            ? null             // consentement : contact sans E2EE
           : confidentialReply  ? 'confidential'   // réponse confidentielle : toujours chiffrée
           : isPublic           ? null             // diffusion publique : jamais d'E2EE de groupe
           : isGroup            ? 'group'
           : recipientId_new    ? 'private'
           : null;


if (!discussion?.isPublic && !mode && !plainOk) {
  await alert(t('discussion.erreur_chiffrement'));
  return;
}
  // Destinataire des messages "pairwise" (privé / confidentiel)
  const pairwiseRecipientId = mode === 'confidential' ? confidentialReply.recipientId : recipientId_new;

  const hasAttachment = !!(fileToSend || audioReady || videoReady || imageReady ||
                           videofileReady || audiofileReady || docReady);

  isSendingRef.current = true;
  if (hasAttachment) setIsModerating(true);

  try {
    const formData = new FormData();
    formData.append('discussionId', discussionId);

    let encrypted = null;                                  // résultat du chiffrement du TEXTE
    const localDisplayText = messageToSend || '';
let failedMembers = [];
    // =================================================================
    // PHASE 1 — Construction du FormData (chiffrement)
    // =================================================================
    try {
      // ---------- Fichier ----------
      if (fileToSend) {
        const fileType = fileToSend.type || '';
        const spec = resolveFileField(fileType);


        if (!spec) {
          await alert(t('discussion.incorrectfile'));
          return;
        }

        const blob = fileToSend instanceof Blob
          ? fileToSend
          : new Blob([fileToSend], { type: fileType || spec.fallbackMime });
        const name = fileToSend.name || spec.fallbackName;

        if (!mode) {
          // 📎 Discussion publique : envoi classique
          formData.append(spec.field, blob, name);
        } else {
          const buf = await blob.arrayBuffer();
          const enc = mode === 'group'


          //  ? await encryptGroupFile(buf, discussion.participants, currentUserId)
	? await encryptGroupFile(buf, currentParticipants, currentUserId)
            : await encryptFile(pairwiseRecipientId, buf);

          const f = spec.field;
          formData.append(`${f}[encryptedFile]`, enc.encryptedFile);
          formData.append(`${f}[fileIv]`, enc.fileIv);
          formData.append(`${f}[keyForSender]`, enc.keyForSender);
          formData.append(`${f}[keyForSenderIv]`, enc.keyForSenderIv);

          if (mode === 'group') {
            formData.append(`${f}[keyForMembers]`, JSON.stringify(enc.keyForMembers));
            formData.append(`${f}[e2eeGroup]`, 'true');
          } else {
            formData.append(`${f}[keyForRecipient]`, enc.keyForRecipient);
            formData.append(`${f}[keyForRecipientType]`, String(enc.keyForRecipientType));
          }

          formData.append(`${f}[originalName]`, name);
          formData.append(`${f}[mimeType]`, fileType);
          formData.append(`${f}[e2ee]`, 'true');

          if (enc.failedMembers?.length) {
            // à utiliser une fois encryptGroupFile passé en allSettled
            console.warn('Fichier non chiffré pour :', enc.failedMembers);
          }
        }
      }

      // ---------- Texte ----------
      if (messageToSend) {
        if (!mode) {
          formData.append('text', messageToSend);
          formData.append('e2ee', 'false');
        } else {
          encrypted = mode === 'group'

            //? await encryptGroupMessage(messageToSend, discussion.participants, currentUserId)
		? await encryptGroupMessage(messageToSend, currentParticipants, currentUserId)
            : await encryptMessage(pairwiseRecipientId, messageToSend);

          const d = encrypted.e2eeData;
          formData.append('text', encrypted.encryptedText);
          formData.append('e2ee', 'true');
          formData.append('e2eeTextIv', d.textIv);
          formData.append('e2eeKeyForSender', d.keyForSender);
          formData.append('e2eeKeyForSenderIv', d.keyForSenderIv);

          if (mode === 'group') {
            formData.append('e2eeGroup', 'true');
            formData.append('e2eeKeyForMembers', JSON.stringify(d.keyForMembers));
          } else {
            formData.append('e2eeKeyForRecipient', d.keyForRecipient);
            formData.append('e2eeKeyForRecipientType', String(d.keyForRecipientType));
          }
        }
      } else {
        formData.append('text', '');
        formData.append('e2ee', 'false');
      }

      // ---------- Confidentiel : champs ajoutés UNE seule fois ----------
      if (mode === 'confidential') {
        formData.append('isConfidential', 'true');
        formData.append('confidentialRecipientId', confidentialReply.recipientId);
        formData.append('confidentialRecipientName', confidentialReply.senderName);
        formData.append('confidentialReplyToMessageId', confidentialReply.replyToMessageId);
      }

      formData.append('ambiance', selectedAmbiance || '');
      if (replyTo) formData.append('replyTo', replyTo._id);

    } catch (err) {
 
      console.error('❌ ERREUR CHIFFREMENT E2EE :', err?.message, err?.stack);
if (err.code === 'NO_REACHABLE_MEMBER'){
      await alert(t('discussion.erreur_chiffrement'));
      return; }                                             // la pièce jointe reste sélectionnée
    }

    // =================================================================
    // PHASE 2 — Envoi au serveur
    // =================================================================
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const token = localStorage.getItem('token');

      const response = await api.post(`${API_URL}/api/messages/send`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // ---- Objet local (affichage expéditeur) ----
      const confidential = mode === 'confidential'
        ? {
            isConfidential: true,
            recipientId: confidentialReply.recipientId,
            recipientName: confidentialReply.senderName,
            replyToMessageId: confidentialReply.replyToMessageId,
          }
        : null;

      const e2eeData = encrypted
        ? { encryptedText: encrypted.encryptedText, ...encrypted.e2eeData, group: mode === 'group' }
        : null;

      const dataToSend = {
        _id: response.data._id,
        text: localDisplayText,                            // clair : affichage local UNIQUEMENT
        e2ee: !!encrypted,
        e2eeData,
        confidential,
        ambiance: selectedAmbiance,
        discussionId: response.data.discussion,
        sender: { ...response.data.sender, lang: myLang },
        senderId: response.data.sender._id,
        senderEmail: response.data.sender.email,
        files: response.data.files || null,
        reactions: response.data.reactions || [],
        createdAt: new Date().toISOString(),
        ...(replyTo ? { replyTo: { _id: replyTo._id, senderName: replyTo.senderName } } : {}),
      };

      // ---- Effets d'ambiance ----
      if (selectedAmbiance) {
        setParticlePositionsMap(prev => ({
          ...prev,
          [dataToSend._id]: generateParticles(12),
        }));
        playAmbianceSound(selectedAmbiance);
        setSoundOn(true);
      }

      // ---- Socket : JAMAIS le texte en clair d'un message E2EE ----
      socket.emit('sendMessage', {
        discussionId,
        dataToSend: {
          ...dataToSend,
          text: encrypted ? encrypted.encryptedText : localDisplayText,
        },
      });

      // Aperçu local (liste des discussions) : pas pour les messages confidentiels
      if (onNewMessage && !confidential) {
        onNewMessage(discussionId, dataToSend);
      }

      // ---- Réinitialisation de la zone de saisie (succès uniquement) ----
      setMessage('');
      onClearConfidentialReply?.();
      setSelectedAmbiance(null);
      setSoundOn(true);
      setFile(null);
      setFileType('');
      setAudioReady(false);
      setVideoReady(false);
      setImageReady(false);
      setVideofileReady(false);
      setAudiofileReady(false);
      setDocReady(false);
      setReplyTo(null);
      shouldScrollRef.current = true;
      if (onMessageSent) onMessageSent();

      socket.emit('typing', { userId: currentUserId, isTyping: false, discussionId });
      clearTimeout(typingTimeout.current);

      // Membres non joints (groupe) : prévenir sans bloquer
      if (failedMembers.length) {
     const names = failedMembers.map(
       (id) => discussion.participants.find((p) => String(p?._id || p) === id)?.username || '…'
     );
     await alert(t('discussion.membres_non_joints', { names: names.join(', ') }));
   }


    } catch (error) {
      console.error("Erreur d'envoi du message :", error);
      if (error.response?.status === 403) {
        await alert(t('discussion.moderation'));
        setFile(null);
        setFileType('');
      } else {
        await alert(t('discussion.erreurenvoi'));           // le message et la pièce jointe sont conservés
      }
    }

  } finally {
    setIsModerating(false);
    isSendingRef.current = false;
  }
};


const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
//sons ambiance
  
const oscRef = useRef(null);

const [media, setMedia] = useState(null);
/* global Media, cordova */



useEffect(() => {
  return () => stopAmbianceSound();
}, []);


const ambiance = ambiances[selectedAmbiance] || null;


useEffect(() => {
  const handleTypingSocket = (data) => {
    if (data.userId !== currentUserId && data.discussionId === discussionId) {
      setSomeoneTyping(data.isTyping ? data.username : null);
    }
  };
  socket.on("typing", handleTypingSocket);
  return () => {
    socket.off("typing", handleTypingSocket);
  };
}, [socket, currentUserId, discussionId]);

const containerRef = useRef(null);
const lastMessageRef = useRef(null);
 const formRef = useRef(null);

const requestCameraPermission = async () => {
  const permissions = window?.cordova?.plugins?.permissions;
  if (!permissions) return true;
  return new Promise((resolve) => {  // ← plus de reject
    permissions.hasPermission(permissions.CAMERA, (status) => {
      if (status.hasPermission) {
        resolve(true);
      } else {
        permissions.requestPermission(
          permissions.CAMERA,
          (status) => resolve(status.hasPermission),
          () => resolve(false)  // ← erreur = refus, pas crash
        );
      }
    }, () => resolve(false));  // ← idem
  });
};

// Condition centrale :
    const canSendMessage = !isPublic || (isPublic && currentUserId === creatorId._id);
const canSend = (message.trim() !== '' || file !== null) && !isRecording;

const [showBirthdayCard, setShowBirthdayCard] = useState(false);
const [showNewYearCard, setShowNewYearCard] = useState(false);
const [showLoveCard, setShowLoveCard] = useState(false);
const [showAmbianceCard, setShowAmbianceCard] = useState(false);
const [showCardPanel, setShowCardPanel] = useState(false);
const [showFilePanel, setShowFilePanel] = useState(false);
const [editModal, setEditModal] = useState(null);


const [discussions, setDiscussions] = useState([]); 

// Ferme le panneau utils si on clique/touche ailleurs que le panneau ou le bouton +
useEffect(() => {
  if (!showUtilsPanelBottom) return;

  let touchStartY = 0;
  let touchStartX = 0;

  const handleTouchStart = (e) => {
    touchStartY = e.touches[0].clientY;
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const deltaY = Math.abs(e.changedTouches[0].clientY - touchStartY);
    const deltaX = Math.abs(e.changedTouches[0].clientX - touchStartX);

    // Si déplacement > 10px → c'était un scroll, on ignore
    if (deltaY > 10 || deltaX > 10) return;

    const panel = document.querySelector('.utilsPanel');
    const btn = document.querySelector('.plus');
    if (panel && !panel.contains(e.target) && btn && !btn.contains(e.target)) {
      setShowUtilsPanelBottom(false);
    }
  };

  const handleMouseDown = (e) => {
    const panel = document.querySelector('.utilsPanel');
    const btn = document.querySelector('.plus');
    if (panel && !panel.contains(e.target) && btn && !btn.contains(e.target)) {
      setShowUtilsPanelBottom(false);
    }
  };

  document.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('touchstart', handleTouchStart);
  document.addEventListener('touchend', handleTouchEnd);

  return () => {
    document.removeEventListener('mousedown', handleMouseDown);
    document.removeEventListener('touchstart', handleTouchStart);
    document.removeEventListener('touchend', handleTouchEnd);
  };
}, [showUtilsPanelBottom]);

// 🖱️ Gestion de la sélection
useEffect(() => {
  if (!selectedDiscussion) return;

  const updated = discussions.find(d => d._id === selectedDiscussion._id);
  if (updated && updated !== selectedDiscussion) {
    setSelectedDiscussion(updated);
  }

}, [discussions, selectedDiscussion]);


const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '8px 12px',
    borderRadius: '20px',
    background: 'rgba(255, 0, 0, 0.08)',
    backdropFilter: 'blur(6px)',
  },

  pulse: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: '#ff3b30',
    animation: 'pulse 1.2s infinite',
  },

  text: {
    fontSize: 14,
    fontWeight: 500,
    color: '#ff3b30',
  },

  stopBtn: {
    marginLeft: 'auto',
    background: '#ff3b30',
    border: 'none',
    borderRadius: '50%',
    width: 32,
    height: 32,
    color: 'white',
    fontSize: 14,
    cursor: 'pointer',
  }
};

// fonction tableaux blancs
const [showWhiteboard, setShowWhiteboard] = useState(false);
//const Whiteboard = lazy(() => import('./Whiteboard'));
const whiteboardRef = useRef(null); 

// Fonction pour ouvrir le tableau blanc
  const handleOpenWhiteboard = () => {
    setShowWhiteboard(true);
    //setShowFilePanel(false); // Fermer le panneau slide bottom après clic
  };


const [whiteboardList, setWhiteboardList] = useState([]); // ← tableau vide par défaut

useEffect(() => {
  const fetchWhiteboards = async () => {
    try {
      const response = await api.get(`${API_URL}/api/whiteboards/list/${discussionId}`);
      setWhiteboardList(response.data);
    } catch (error) {
      console.error("Erreur chargement tableaux :", error);
    }
  };
  if (discussionId) fetchWhiteboards();
}, [discussionId]);


const handleOpenWhiteboardFromAgenda = (whiteboardId) => {
  setPreviousView('agenda');
  setShowAgenda(false);          // ← ferme l'agenda
  setSelectedWhiteboardId(whiteboardId); // ← stocke l'id
  setShowWhiteboard(true);       // ← ouvre le whiteboard
};
const [showAgenda, setShowAgenda] = useState(false);


useEffect(() => {

  if (openAgenda) {

    setShowAgenda(true);

    setOpenAgenda(false);
  }

}, [openAgenda]);


const [selectedWhiteboardId, setSelectedWhiteboardId] = useState(null);

const [previousView, setPreviousView] = useState(null);

const [isEditingManually, setIsEditingManually] = useState(false);
const [isWhiteboardOpen, setIsWhiteboardOpen] = useState(false);


useEffect(() => {
  if (openAgenda && discussion) {

    setShowAgenda(true);


    // reset
    setOpenAgenda(false);
  }

}, [openAgenda, discussion]);

const handleCloseWhiteboard = () => {
  setShowWhiteboard(false);
  setSelectedWhiteboardId(null);
setShowUtilsPanelBottom(true);
  // ← restaure la vue précédente
  if (previousView === 'agenda') {
    setShowAgenda(true);
  }
  setPreviousView(null);
};

// Calculer si le bouton est sous le panneau slide bottom
const isButtonUnderPanel = () => {
  // Le panneau slide bottom est en `bottom: 0` quand il est ouvert.
  // Le bouton est en `bottom: 26px`.
  // Donc, si le panneau est ouvert (`showFilePanel === true`), le bouton est sous le panneau.
  return showFilePanel;
};


return (

  <div >

{canSendMessage && (
   

    <div ref={formRef } className="floating-form" >
      
{confidentialReply && (
  <div style={{
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '6px 10px', marginBottom: '6px',
    background: 'var(--color-background-secondary)',
    borderLeft: '3px solid var(--color-text-secondary)',
    borderRadius: '4px', fontSize: '0.85em',
    color: 'var(--color-text-secondary)'
  }}>
    🔒 {t('discussion.replyingConfidentiallyTo', { name: confidentialReply.senderName })}
    <button
      onClick={onClearConfidentialReply}
      style={{ background: 'none', border: 'none',
               cursor: 'pointer', marginLeft: 'auto', fontSize: '16px' }}
    >✕</button>
  </div>
)}
{replyTo && (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px',
    background: 'var(--input-bg)',
    borderLeft: '3px solid #007bff',
    borderRadius: '0 8px 8px 0',
    margin: '0 8px 4px',
  }}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <span style={{ fontSize: '11px', fontWeight: '600', color: '#007bff' }}>
        {replyTo.senderName}
      </span>
      <p style={{
        fontSize: '12px', margin: 0, opacity: 0.7,
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        color: 'var(--text-color)',
      }}>
        {replyTo.text.slice(0, 80)}{replyTo.text.length > 80 ? '…' : ''}
      </p>
    </div>
    <button
      onClick={() => setReplyTo(null)}
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, flexShrink: 0 }}
    >
      <i className="ti ti-x" style={{ fontSize: '14px', opacity: 0.5, color: 'var(--text-color)' }} aria-hidden="true" />
    </button>
  </div>
)}
      <div className="input-bar">

  

  {/* zone textarea + bouton send */}
  <div className="textarea-wrapper">
    <textarea
      id="messageInput"
      className="envoi_message"
      rows={2}
      value={message}
      onChange={(e) => {
    handleTyping(e);
    setIsEditingManually(true); // ← Marquer comme édition manuelle
  }}
  onFocus={() => setIsEditingManually(true)}
      placeholder={t('discussion.ecrire')}
    />

<button
className="plus"
  onClick={() => {setShowUtilsPanelBottom(!showUtilsPanelBottom); setShowFilePanel(false);}}
  style={{
        transform: showUtilsPanelBottom ? 'rotate(45deg)' : 'rotate(0deg)', 
width: showUtilsPanelBottom ? '25px' : '30px',
  height: showUtilsPanelBottom ? '25px' : '30px',
color: showUtilsPanelBottom ? '#fff' : '#007bff',
borderColor: showUtilsPanelBottom ? '#fff' : '#007bff',
background: showUtilsPanelBottom ? '#007bff' : 'none',
opacity: showUtilsPanelBottom ? '0.6' : '0.6',
    flexShrink: 0,
    
  }}
  title={t('utils.panel_title')}

>
  +
</button>

{/* Gomme — visible uniquement si du texte est présent */}
  {message.trim() !== '' && (
    <button
      className="eraser"
      style={{ fontSize: '18px' }}
      onClick={() => {
        handleTyping({ target: { value: '' } });
        setIsEditingManually(false);
        document.getElementById('messageInput').focus();
      }}
      title="Effacer le texte"
    >
       <i className="ti ti-eraser" style={iconEraserStyle} aria-hidden="true" />

    </button>
  )}

<button
      onClick={() => setShowFilePanel(!showFilePanel)}
className="fichier"
     style={{ fontSize: '18px' }}
    >
      <i className="ti ti-paperclip"  style={iconFileStyle} aria-hidden="true" />

    </button>
</div>


    

{/* Panneau d'état — enregistrement, fichiers prêts, modération */}
{(isRecording || audiofileReady || audioReady || imageReady || videoReady || videofileReady || docReady || isModerating) && (
  <div style={{
    position: "fixed",
bottom: "calc(var(--floating-form-bottom, 10px) + 80px)",

    right: "10px",
    background: "white",
    border: "0.5px solid rgba(0,0,0,0.1)",
    borderRadius: "12px",
    padding: "14px 16px",
    width: "240px",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  }}>
    {isRecording ? (
      // ← enregistrement en cours
      <>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#E24B4A', flexShrink: 0,
            animation: 'blink 1s step-start infinite'
          }} />
          <span style={{ fontSize: 13, color: '#666', flex: 1 }}>
            {t('discussion.recording')}
          </span>
          <span style={{ fontSize: 13, fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
            {Math.floor(recordingSeconds / 60)}:{String(recordingSeconds % 60).padStart(2, '0')}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 3, height: 28 }}>
          {[8,16,22,14,26,18,10,20,14].map((h, i) => (
            <div key={i} style={{
              width: 3, height: h, borderRadius: 2,
              background: '#1D9E75',
              animation: `wave 0.8s ease-in-out ${i * 0.05}s infinite alternate`,
            }} />
          ))}
        </div>
      </>

    ) : isModerating ? (
      // ← modération en cours
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div className="spinner" />
        <span style={{ fontSize: 13, color: '#007bff' }}>
          {t('discussion.moderate')}
        </span>
      </div>

    ) : (
      // ← fichier prêt
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ color: '#1D9E75', fontSize: 15 }}>✓</span>
        <span style={{ fontSize: 13, color: '#666', flex: 1 }}>
          {audiofileReady && t('discussion.audioready')}
	  {audioReady && t('discussion.audioready')}
          {imageReady && t('discussion.imageready')}
          {videoReady && t('discussion.videoready')}
          {videofileReady && t('discussion.videoready')}
          {docReady && t('discussion.docready')}
        </span>

        {/* ← croix suppression */}
        <button
          onClick={() => {
            if (audiofileReady) { setAudiofileReady(false); setFile(null); }
	    if (audioReady) { setAudioReady(false); setFile(null); }
            if (imageReady) { setImageReady(false); setFile(null); }
            if (videoReady) { setVideoReady(false); setFile(null); }
            if (videofileReady) { setVideofileReady(false); setFile(null); }
            if (docReady) { setDocReady(false); setFile(null); }
          }}
          style={{
            background: 'none', border: 'none', cursor: 'pointer', color: 'red',
            color: '#999', fontSize: 14, padding: '0 2px', 
            flexShrink: 0, lineHeight: 1,
          }}
          title={t('discussion.cancelFile')}
        >
          ✕
        </button>
      </div>
    )}
  </div>
)}


{/* Bouton micro / send */}
  <button
    className={`send-btn ${isRecording ? 'recording' : ''} ${canSend ? 'can-send' : ''}`}
    onClick={() => {
      if (canSend) { handleSendMessage(); setShowUserList(false);}
      else { isRecording ? recorderRef.current?.stop() : handleIconClick('audio-record'); }
    }}
  >
    <i style = {{fontSize: '20px' }} className={canSend ? "ti ti-send" : isRecording ? "ti ti-player-stop" : "ti ti-microphone"} />
  </button>

</div>
    {someoneTyping && (
  <div id="typingIndicator">👀 {someoneTyping} {t('discussion.typing')}<span className="dots"><span>.</span><span>.</span><span>.</span></span></div>
)}
  

{showAmbianceCard && (
  <AmbianceCardModal
    onSend={async (file) => {
      const fileType = typeof file.type === 'string' ? file.type : 'image/png';
      setFile(file);
      setFileType(fileType);
      setImageReady(true);
      setTimeout(() => handleSendMessage(null, file), 100);
      setShowAmbianceCard(false);
    }}
    onClose={() => setShowAmbianceCard(false)}
  />
)}


{showLoveCard && (
  <LoveCardModal
    onSend={async (file) => {
      const fileType = typeof file.type === 'string' ? file.type : 'image/png';
      setFile(file);
      setFileType(fileType);
      setImageReady(true);
      setTimeout(() => handleSendMessage(null, file), 200);
      setShowLoveCard(false);
    }}
    onClose={() => setShowLoveCard(false)}
  />
)}


{showNewYearCard && (
  <NewYearCardModal
   
    onSend={async (file) => {
  
  
  // ← Forcer le type en string explicitement
  const fileType = typeof file.type === 'string' ? file.type : 'image/png';
  
  setFile(file);
  setFileType(fileType);
  setImageReady(true);
  
  setTimeout(() => {
    handleSendMessage(null, file);
  }, 200);
  
  setShowNewYearCard(false);

}}
onClose={() => setShowNewYearCard(false)} 
  />
)}


{showBirthdayCard && (
  <BirthdayCardModal
   
    onSend={async (file) => {
   setShowBirthdayCard(false);
  
  // ← Forcer le type en string explicitement
  const fileType = typeof file.type === 'string' ? file.type : 'image/png';
  
  setFile(file);
  setFileType(fileType);
  setImageReady(true);
  
  setTimeout(() => {
    handleSendMessage(null, file);
  }, 100);
  
  setShowBirthdayCard(false);

}}
onClose={() => setShowBirthdayCard(false)} 
  />
)}



{/* Tableau blanc (affiché si showWhiteboard est true) */}
    {showWhiteboard && (

  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 5000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    {/* Header modal */}
    <div style={{
      width: '100%',
      maxWidth: 840,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 12px',
      backgroundColor: 'var(--input-bg)',
      borderRadius: '12px 12px 0 0',
      // ← PAS de height ici, pas de overflow
    }}>
      <span style={{ fontWeight: 'bold' }}>📝 Tableau blanc</span>
      <button
        onClick={() => setShowWhiteboard(false)}
        style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer' }}
      >
        ✕
      </button>
    </div>

    {/* Contenu */}
    <div style={{
      backgroundColor: 'var(--bg-color)',
      width: '100%',
      maxWidth: 840,
      height: '650px',        // ← height ici
      borderRadius: '0 0 12px 12px',
      overflow: 'auto',       // ← auto et non hidden
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Whiteboard
	 ref={whiteboardRef} 
        discussionId={discussionId}
	discussionName={discussionTitle}
        userId={currentUserId}
        socket={socket}
	prompt={prompt}
        initialWhiteboardId={selectedWhiteboardId} // ← charge directement ce tableau
  	onClose={handleCloseWhiteboard}
      />
    </div>
  </div>

)}


<input
  type="file" accept="image/*" capture="environment"
  ref={imageInputRef} style={{ display: 'none' }}
  onChange={handleFileChange}
/>

<DiscussionPanels
showAutoDeleteModal={showAutoDeleteModal} setShowAutoDeleteModal={setShowAutoDeleteModal}
autoDeleteAfter={autoDeleteAfter} setAutoDeleteAfter={setAutoDeleteAfter}
  showFilePanel={showFilePanel} setShowFilePanel={setShowFilePanel}
  showCardPanel={showCardPanel} setShowCardPanel={setShowCardPanel}
showUtilsPanelBottom={showUtilsPanelBottom} setShowUtilsPanelBottom={setShowUtilsPanelBottom}
  showUserList={showUserList} setShowUserList={setShowUserList}
  showParticipantsList={showParticipantsList} setShowParticipantsList={setShowParticipantsList}
  showSearch={showSearch} setShowSearch={setShowSearch}
  imageInputRef={imageInputRef} videoInputRef={videoInputRef}
onCameraClick={handleCameraClick}
  audioInputRef={audioInputRef} pdfInputRef={pdfInputRef}
  handleIconClick={handleIconClick} handleFileChange={handleFileChange}
  requestCameraPermission={requestCameraPermission}
  setShowBirthdayCard={setShowBirthdayCard} setShowLoveCard={setShowLoveCard}
  setShowAmbianceCard={setShowAmbianceCard} setShowNewYearCard={setShowNewYearCard}
  isPublic={isPublic} isCreator={isCreator} isMobile={isMobile}
  participants={participants} discussion={discussion}
  currentUserId={currentUserId} discussionId={discussionId}
  selectedDiscussion={selectedDiscussion}
  onEdit={onEdit} setEditModal={setEditModal}
  handleLeaveDiscussionPrivate={handleLeaveDiscussionPrivate}
  handleDeleteDiscussion={handleDeleteDiscussion}
  handleInviteClick={handleInviteClick} handleInviteUser={handleInviteUser}
  handleOpenWhiteboard={handleOpenWhiteboard}
  setShowAgenda={setShowAgenda} startVideoCall={startVideoCall}
  prompt={prompt}
/>

{editModal && (
  <EditDiscussionModal
    discussion={editModal}
    decryptedTitle={discussionTitle}
    decryptedDescription={decryptedDescription}
    onClose={() => setEditModal(null)}
    onUpdated={(updated) => {
  socket.emit("user_update_discussion", {
    updatedDiscussion: updated
  });

      // ⚡ Fusionne pour ne pas perdre les infos du bloc
       setDiscussions((prev) =>
    prev.map((d) =>
      d._id === updated._id ? { ...d, ...updated } : d
    )
  );

// setEditModal(updated);
setSelectedDiscussion(prev =>
    prev && prev._id === updated._id
      ? { ...prev, ...updated }
      : prev
  );
    

    }}


  />
)}

{showAutoDeleteModal && (
  <ModalAutoDelete
    discussionId={discussionId}
    currentValue={autoDeleteAfter}
    onClose={() => setShowAutoDeleteModal(false)}
    onSaved={(val) => setAutoDeleteAfter(val)}
  />
)}

{showAgenda && (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 5000,
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
  }}>
    <div style={{
      backgroundColor: 'var(--bg-color)', width: '100%', maxWidth: 900,
      height: '85vh', borderRadius: 12, overflow: 'auto', padding: 16,
    }}>
      <Agenda
        discussionId={discussionId}
	discussionName={discussionTitle}
	discussionCreatedBy={creatorId._id}
        userId={currentUserId}
        socket={socket}
        prompt={prompt}
        onClose={async () => {setShowAgenda(false); setShowUtilsPanelBottom(true);}}
        whiteboardList={whiteboardList} // ← liste des tableaux de la discussion
	onOpenWhiteboard={handleOpenWhiteboardFromAgenda}
	highlightEventId={highlightEventId}
	setHighlightEventId={setHighlightEventId}
      />
    </div>
  </div>
)}


{/* Overlay pour fermer en cliquant dehors */}
{showCardPanel && (
  <div
    onClick={() => setShowCardPanel(false)}
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 2999,
      background: 'rgba(0,0,0,0.2)',
    }}
  />
)}

{/* Overlay pour fermer en cliquant dehors */}
{showFilePanel && (
  <div
    onClick={() => setShowFilePanel(false)}
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 2999,
      background: 'rgba(0,0,0,0.2)',
    }}
  />
)}



      
    </div>
)}
  </div>

);

});

// Composant principal récupérer les messages

function Discussion({ discussionId, discussionName, videoUrl, onDiscussionDeleted, onDiscussionPublicDeleted, socket, userObj, prompt, setCallInProgress, isPublic, visibility, onConfidentialReply, selectedDiscussion, setSelectedDiscussion, onEdit, handleJoin, handleLeave, isMemberSelected, onLeave, onDiscussionPublicLeave, description, allowComments, onNewMessage, onMessageDeleted, onMessageUpdated, onLoadStart, onLoadEnd, openAgenda, setOpenAgenda, highlightEventId, setHighlightEventId}) {

  const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];
  const [discussionTitle, setDiscussionTitle] = useState('');
  const [messages, setMessages] = useState([]);
const [message, setMessage] = useState('');
const [selected, setSelected] = useState(null);
const [selectedImage, setSelectedImage] = useState(null);
const [currentUserId, setCurrentUserId] = useState(null);

const [currentUser, setCurrentUser] = useState(null);
const [user, setUser] = useState(null);
const [showUserList,setShowUserList] = useState(false);
const [showParticipantsList, setShowParticipantsList] = useState(false);
const [showWhiteboard, setShowWhiteboard] = useState(false);
//const [pendingInvitations, setPendingInvitations] = useState([]);
//const [discussion, setDiscussion] = useState(null);
const [discussion, setDiscussion] = useState(selectedDiscussion ?? null);
const [autoDeleteAfter, setAutoDeleteAfter] = useState(discussion?.autoDeleteAfter ?? null);
const [showExpirationInfo, setShowExpirationInfo] = useState(false);
const getTTLLabel = (value) => {
  if (!value) return t('duree.jamais');
  if (value === 365) return t('duree.an', { count: 1 });
  return t('duree.jour', { count: value });
};

const [bannerDismissed, setBannerDismissed] = useState(false);

const [replyTo, setReplyTo] = useState(null);
 const navigate = useNavigate();
const [modalImageUrl, setModalImageUrl] = useState(null);

const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
const [translatedMessage, setTranslatedMessage] = useState("");

const [editingMessage, setEditingMessage] = useState(null);
const [editedText, setEditedText] = useState('');
const [editedYoutubeUrl, setEditedYoutubeUrl] = useState('');
const [confidentialReply, setConfidentialReply] = useState(null);

const [permissionGranted, setPermissionGranted] = useState(false);

const pendingReloadRef = useRef(false);
const fetchLatestRef = useRef(null);


const [showUtilsPanelBottom, setShowUtilsPanelBottom] = useState(false);
const shouldScrollRef = useRef(true);
const textareaRef = useRef(null);
useEffect(() => {
  const ta = textareaRef.current;
  if (!ta) return;
  ta.style.height = 'auto';           // reset pour recalculer
  ta.style.height = `${Math.min(ta.scrollHeight, 200)}px`; // max 200px
}, [editedText, editedYoutubeUrl]);

const handleConfidentialReply = (replyInfo) => {
  setConfidentialReply(prev => 
    prev?.replyToMessageId === replyInfo.replyToMessageId ? null : replyInfo
  );
};
const ambiances = useAmbianceConfig();
const { soundOn, setSoundOn, playAmbianceSound, stopAmbianceSound } = useAmbiance();

const [failedFileIds, setFailedFileIds] = useState(new Set());

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const [particlePositionsMap, setParticlePositionsMap] = useState({});
const [someoneTyping, setSomeoneTyping] = useState(false);
//const EmojiPicker = lazy(() => import('emoji-picker-react'));
const [showEmojiPicker, setShowEmojiPicker] = useState(false);
const [showFullPicker, setShowFullPicker] = useState(false);
const [emojiList, setEmojiList] = useState([
  '👍',  // Like
  '🙂​', //heureux
  '😁', //jaune
  '❤️',  // Love
  '😂',  // Rire
  '😮',  // Surprise
  '😢',  // Triste
  '😡',  // Colère
  '🎉',  // Fête / Bravo
  '✨',  // Félicitations / Étoiles
  '😎',  // Cool / Top
  '🙏',  // Merci / Prière
  '💯'   // Parfait / 100%
]);

const [whiteboardList, setWhiteboardList] = useState([]);
const [editModal, setEditModal] = useState(null);

// Décoder les crédits carte ambiance depuis le nom du fichier
const getAmbianceCredit = (files) => {
const fileName = Object.values(files).find(f =>
    f?.originalName?.startsWith('ambiance-card-')
  )?.originalName || '';

  // ambiance-card-tibet-2-1234567890.png
  const match = fileName.match(/ambiance-card-(\w+)-(\d+)-\d+/);
  if (!match) return null;

  const templateId = match[1];
  const imageIndex = parseInt(match[2]);
  return AMBIANCE_IMAGES[templateId]?.[imageIndex] || null;
};


useEffect(() => {
  document.documentElement.style.setProperty(
    '--floating-form-bottom',
    showUtilsPanelBottom ? '70px' : '10px'
  );
}, [showUtilsPanelBottom]);


//décoder crédits sons
const getAmbianceSoundCredit = (files) => {
  const fileName = Object.values(files).find(f =>
    f?.originalName?.startsWith('ambiance-card-')
  )?.originalName || '';

  const match = fileName.match(/ambiance-card-(\w+)-/);
  if (!match) return null;

  const templateId = match[1];

  return AMBIANCE_SOUNDS[templateId] || null;
};

useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
    
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);


const [longPressTimer, setLongPressTimer] = useState(null);
const emojiPickerRef = useRef(null);
const fullPickerRef = useRef(null);
useEffect(() => {
  const handleClickOutside = (e) => {
    const inEmoji = emojiPickerRef.current?.contains(e.target);
    const inFull = fullPickerRef.current?.contains(e.target);

    if (!inEmoji && !inFull) {
      setShowEmojiPicker(null);
      setShowFullPicker(false);
    }
  };

  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);

const [notifications, setNotifications] = useState(''); 
 const [fcmToken, setFcmToken] = useState(null);
const { t } = useTranslation();
const myLang = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];

const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [lightboxIndex, setLightboxIndex] = useState(0);
const [lightboxOpen, setLightboxOpen] = useState(false);
const [lightboxSrc, setLightboxSrc] = useState("");
const [lightboxLoading, setLightboxLoading] = useState(false);
const [e2eeImageUrls, setE2eeImageUrls] = useState({});



const [activeMessage, setActiveMessage] = useState(null);

const [selectedAmbiance, setSelectedAmbiance] = useState(null);
const audioCtxRef = useRef(null);
const nodesRef = useRef({});
const intervalsRef = useRef([]);
const oscRef = useRef(null);

const [media, setMedia] = useState(null);
/* global Media, cordova */


useEffect(() => {
  return () => stopAmbianceSound();
}, []);

// ---------------------------
// ⚙️ Fonction search
// ---------------------------

const [showSearch, setShowSearch] = useState(false);
const [searchQuery, setSearchQuery] = useState('');
const [searchResults, setSearchResults] = useState([]);
const [isSearching, setIsSearching] = useState(false);
const [searchPreview, setSearchPreview] = useState(null);

const sendZoneRef = useRef(null);



const handleSearch = async (q) => {
  setSearchQuery(q);
  if (q.trim().length < 2) { setSearchResults([]); return; }
  setIsSearching(true);
  try {
    const res = await api.get(
      `${API_URL}/api/messages/${discussionId}/search?q=${encodeURIComponent(q)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setSearchResults(res.data.results);
  } catch (e) {
    console.error(e);
  } finally {
    setIsSearching(false);
  }
};
// ---------------------------
// ⚙️ Fonction d’insertion quizz
// ---------------------------

const visibleMessages = messages.filter(msg => {
  const isOwnMessage = String(msg.sender?._id) === String(currentUserId);
  return !msg.decryptFailed || isOwnMessage;
});

const enhancedMessages = [];

visibleMessages.forEach((msg, index) => {
  enhancedMessages.push(msg);

  // Tous les 3 messages, on injecte un quiz
  if ((index + 1) % 15 === 0) {
    // Choisir un thème aléatoire ou cyclique
    const themes = ['histoire', 'géographie', 'science'];
    const theme = themes[Math.floor(Math.random() * themes.length)];

    enhancedMessages.push({
      _id: `quiz-${index}`,
      type: 'quiz',
      quiz: {
        title: `Quiz ${theme.charAt(0).toUpperCase() + theme.slice(1)} 🎯`,
        buttonText: 'Jouer au quiz',
        url: `/quiz/${theme}` // <--- chemin concret
      }
    });
  }
});


function openQuizPage(quiz) {
  navigate(quiz.url || '/quiz');
}

// ---------------------------
// ⚙️ Fonction d’insertion d’annonce native
// ---------------------------
const insertNativeAdInChat = (ad) => {
  setMessages((prev) => {
    const newMessages = [...prev];

    // Compte les messages normaux
    const nonAdCount = newMessages.filter(m => m.type !== 'ad').length;

    // Compte les annonces déjà présentes
    const adCount = newMessages.filter(m => m.type === 'ad').length;

    // 👉 Une annonce toutes les 3 discussions
    const nextAdPosition = (adCount + 1) * 6 - 1; // après chaque bloc de 3 messages

    if (nonAdCount < 5 || newMessages.length < nextAdPosition) {
      
      return newMessages;
    }

    // Vérifie si une annonce est déjà à cette position
    if (newMessages[nextAdPosition]?.type === 'ad') {
     
      return newMessages;
    }

    const adMessage = {
      _id: 'ad-' + Date.now(),
      type: 'ad',
      ad,
    };

    // Insère l’annonce à la position calculée
    newMessages.splice(nextAdPosition, 0, adMessage);

    // 🔹 Propagation socket + sauvegarde locale
    socket.emit('newMessage', adMessage);
    localStorage.setItem('chatMessages', JSON.stringify(newMessages));

    
    return newMessages;
  });
};

useEffect(() => {
  const savedMessages = localStorage.getItem('chatMessages');
  if (savedMessages) {
    const parsed = JSON.parse(savedMessages);
    
    setMessages(parsed);
  } else {
    
  }
}, []);

  // 📱 Fonction pour charger une annonce native depuis le plugin
  const loadNativeAd = () => {

    if (!window.cordova) return;
const options = {
    adUnitId: 'ca-app-pub-3940256099942544/2247696110',
    keywords: ['quiz', 'jeu', 'éducation'],
    style: 'small',          // 🔸 format texte compact
    includeImages: false,    // 🔸 désactiver les visuels
    contentUrl: 'https://clavardage.cloud', // contexte optionnel
    requestNonPersonalizedAdsOnly: true, // GDPR friendly
      };

    window.cordova.exec(
      (ad) => {
      insertNativeAdInChat(ad);

      },
      (err) => {
        console.error('Erreur chargement native ad', err);
      },
      'AdMob',
      'showNative',
      [options]
    );
  };

  useEffect(() => {
  if (!window.cordova) return;

  const nonAdMessages = messages.filter(m => m.type !== 'ad');

  if (nonAdMessages.length > 0 && nonAdMessages.length % 5 === 0) {
   
  }
}, [messages]);

useEffect(() => {
  const now = Date.now();
  const cleaned = messages.filter(msg => {
    if (msg.type !== 'ad') return true;
    const age = now - parseInt(msg._id.replace('ad-', ''), 10);
    return age < 24 * 60 * 60 * 1000; // conserve moins de 24h
  });

  if (cleaned.length !== messages.length) {
    localStorage.setItem('chatMessages', JSON.stringify(cleaned));
    setMessages(cleaned);
  }
}, [messages]);



//fonction pour atteindre le dernier message

const containerRef = useRef(null); // le conteneur scrollable (.message-list ou .message-scroll-zone)
const lastMessageRef = useRef(null); // ref appliquée au dernier message
const formRef = useRef(null); // ref appliquée au composant SendMessage (forwardRef)
const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
const autoScrollTimeoutRef = useRef(null);
const isInitialLoad = useRef(true);


const chatContainerRef = useRef(null);
const [showScrollButton, setShowScrollButton] = useState(false);
const [oldestMessageDate, setOldestMessageDate] = useState(null);
const [hasMoreMessages, setHasMoreMessages] = useState(true);

const imageMessages = messages.filter(msg => msg.files?.image);
const token = localStorage.getItem('token');

// 1. Ouvrir le modal (sans déchiffrer)
const handleImageClick = (index) => {
  setLightboxIndex(index);
  setLightboxOpen(true);
};

// 2. Déchiffrer l'image ACTUELLE quand on navigue
useEffect(() => {
  if (!lightboxOpen) return;

  const decryptCurrentImage = async () => {
    const msg = imageMessages[lightboxIndex];
    if (!msg?.files?.image?.e2ee) return;  // Non E2EE → rien à faire
    if (e2eeImageUrls[msg._id]) return;    // Déjà déchiffrée

    try {
      const decryptedBytes = await decryptFile(
        msg.files.image,
        msg.senderId || msg.sender?._id,
        currentUserId,
        `${msg._id}:image`
      );
      const blob = new Blob([decryptedBytes], { type: msg.files.image.mimeType || 'image/jpeg' });
      const url = URL.createObjectURL(blob);

      setE2eeImageUrls(prev => ({ ...prev, [msg._id]: url }));
    } catch (err) {
      console.error('❌ Erreur déchiffrement:', err);
    }
  };

  decryptCurrentImage();
}, [lightboxIndex, lightboxOpen, imageMessages, currentUserId, e2eeImageUrls]);


// ✅ Garder une référence toujours à jour
const e2eeImageUrlsRef = useRef({});

useEffect(() => {
  e2eeImageUrlsRef.current = e2eeImageUrls;
}, [e2eeImageUrls]);

// ✅ Nettoyage UNIQUEMENT au démontage du composant
useEffect(() => {
  return () => {
    Object.values(e2eeImageUrlsRef.current).forEach(url => {
      if (url) URL.revokeObjectURL(url);
    });
  };
}, []);  // ✅ Tableau de dépendances VIDE = cleanup seulement à l'unmount

 // Préparer les slides
 const slides = useMemo(() => {
  return (imageMessages || [])
    .filter(img => img.files?.image)
    .map(msg => {
      const fileData = msg.files.image;
      const isE2EE = fileData.e2ee;

      if (isE2EE) {
        // ✅ Utiliser l'URL du state (peut être undefined, mais le modal ne s'ouvre que si elle existe)
        return {
          src: e2eeImageUrls[msg._id] || '',  // ✅ L'URL sera là après déchiffrement
          download: e2eeImageUrls[msg._id] || '',
          alt: fileData.originalName
        };
      }

      return {
        src: `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg._id}?token=${token}&type=image`,
        download: `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg._id}?token=${token}&type=image&download=true`,
        alt: fileData.originalName
      };
    });
}, [imageMessages, token, e2eeImageUrls]);


  // Téléchargement Cordova
  const downloadImageCordova = useCallback(async (url, filename) => {
    if (!window.cordova) return;

    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const targetDir = cordova.file.externalRootDirectory + "Download/";

      window.resolveLocalFileSystemURL(targetDir, (dirEntry) => {
        dirEntry.getFile(
          filename,
          { create: true, exclusive: false },
          (fileEntry) => {
            fileEntry.createWriter((fileWriter) => {
              fileWriter.onwriteend = () =>
                alert(`Fichier téléchargé : ${targetDir}${filename}`);
              fileWriter.onerror = (e) => console.error("fileWriter error:", e);
              fileWriter.write(blob);
            });
          }
        );
      });
    } catch (err) {
      console.error("downloadImageCordova error:", err);
      alert("Téléchargement échoué");
    }
  }, []);

  // Handler téléchargement universel
  const handleDownloadCurrent = useCallback(() => {
    const slide = slides[lightboxIndex] || slides[0];
    if (!slide) return;

    const url = slide.download || slide.src;
    const filename = `image-${lightboxIndex}.jpg`;

    if (window.cordova) {
      downloadImageCordova(url, filename);
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  }, [slides, lightboxIndex, downloadImageCordova]);


useEffect(() => {
    // Récupérer l'ID de l'utilisateur à partir du token
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setCurrentUserId(decodedToken.id); // Stocker l'ID de l'utilisateur actuel
    }

  }, []);

useEffect(() => {
  const fetchProfile = async () => {
    try {
      if (!currentUserId) return;

      const token = localStorage.getItem('token');
      const response = await api.get(`${API_URL}/api/profil/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCurrentUser(response.data); // Contiendra .lang
    } catch (error) {
      console.error("Erreur lors de la récupération du profil :", error);
    }
  };
  fetchProfile();
}, [currentUserId]);

const autoTranslate = currentUser?.settings?.autoTranslate;


// ────────────────────────────────────────────────────────────
// Préchargement images
// ────────────────────────────────────────────────────────────

const preloadImages = (urls = []) => {
  return Promise.all(
    urls.map(
      (url) =>
        new Promise((resolve) => {
          const img = new Image();
          img.src = url;
          img.onload = resolve;
          img.onerror = resolve; // ne bloque pas si erreur
        })
    )
  );
};


// Calculer recipientId pour les discussions 1-à-1
const currentParticipants = useMemo(() => {
  if (Array.isArray(discussion?.participants) && discussion.participants.length > 0) {
    return discussion.participants;
  }
  return Array.isArray(participants) ? participants : [];
}, [participants, discussion?.participants]);

// Identifiants, que les participants soient des objets { _id } ou de simples chaînes
const otherParticipantIds = useMemo(
  () =>
    currentParticipants
      .map((p) => String(p?._id || p))
      .filter((id) => id !== String(currentUserId)),
  [currentParticipants, currentUserId]
);

const recipientId_new = otherParticipantIds[0] ?? null;

const waitingForParticipant = !discussion?.isPublic && otherParticipantIds.length === 0;


//const recipientId_new = discussion.participants.find(p => p._id !== currentUserId);
//const recipientId_new = discussion.participants.find(p => p._id !== currentUserId)?._id;

const MAX_MESSAGES = parseInt(process.env.REACT_APP_MAX_MESSAGES_FETCH || '10', 10);

const loadingOlderRef = useRef(false);
 

const fetchDiscussionData = useCallback(async (before = null) => {
  if (loadingOlderRef.current) {
    if (before === null) pendingReloadRef.current = true;
    return;
  }


  loadingOlderRef.current = true;

  if (before === null && onLoadStart) {
    onLoadStart();
  }

  try {
    const token = localStorage.getItem('token');
    const isInitial = before === null;

    if (isInitial) {
      isInitialLoad.current = true;
    } else {
      isInitialLoad.current = false;
    }

    if (!currentUserId) return;

    // =====================================================
    // 🔐 TRAITEMENT COMMUN DES MESSAGES
    // =====================================================

    const processMessages = async (rawMessages) => {
  const e2eeIdx = rawMessages
    .map((m, i) => (m.e2ee && m.e2eeData ? i : -1))
    .filter((i) => i >= 0);

  const decrypted = await decryptBatch(e2eeIdx.map((i) => rawMessages[i]), currentUserId);
  const byIndex = new Map(e2eeIdx.map((idx, k) => [idx, decrypted[k]]));

  const failedBySender = new Map();          // expéditeur -> première erreur

  const result = rawMessages.map((msg, i) => {
    const r = byIndex.get(i);

    if (!r) {
      // chiffré mais sans enveloppe : illisible, on n'affiche pas du base64 tel quel
      if (msg.e2ee && !msg.e2eeData) return { ...msg, decryptedMessage: null, text: null };
      return { ...msg, decryptedMessage: msg.text, text: msg.text };        // message non chiffré
    }
    if (r.ok) return { ...msg, decryptedMessage: r.text, text: r.text };

    console.error('Erreur déchiffrement E2EE :', msg._id, r.err?.code || r.err?.message);
    const sender = String(msg.sender?._id || msg.senderId || '');
    if (sender && sender !== String(currentUserId) && !failedBySender.has(sender)) {
      failedBySender.set(sender, r.err);
    }
    return { ...msg, decryptedMessage: null, text: null };
  });

  // une seule demande par expéditeur, quel que soit le nombre de messages illisibles
  for (const [sender, err] of failedBySender) {
    healSignalError(socket, sender, discussionId, err).catch(() => {});
  }
  return result;
};



    // =====================================================
    // 📥 CHARGEMENT INITIAL
    // =====================================================

    if (!before) {

      const contacts = JSON.parse(
        localStorage.getItem('contacts') || '[]'
      );

      const contactEmails = contacts
        .filter(c => c.email)
        .map(c => c.email);

      const [
        discussionResponse,
        messagesResponse
      ] = await Promise.all([

        api.get(
          `${API_URL}/api/discussions/${discussionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: {
              contactEmails:
                JSON.stringify(contactEmails)
            },
            withCredentials: true,
          }
        ),

        api.get(
          `${API_URL}/api/messages/${discussionId}/messages`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: {
              limit: MAX_MESSAGES
            },
            withCredentials: true,
          }
        )
      ]);

      setDiscussion(discussionResponse.data);

      // Préchargement avatars
      if (discussionResponse.data.participants) {
        const imageUrls =
          discussionResponse.data.participants
            .filter(p => p.profileImage)
            .map(p =>
              `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${p._id}?token=${token}&type=image&thumb=true&profile=true&t=${p.profileImageUpdatedAt || 0}`
            );

        if (imageUrls.length > 0) {
          preloadImages(imageUrls);
        }
      }

      const rawMessages =
        messagesResponse.data.messages || [];

      if (messagesResponse.data.oldest) {
        setOldestMessageDate(
          new Date(messagesResponse.data.oldest)
        );
      }

      if (rawMessages.length === 0) {
        setMessages([]);
        setHasMoreMessages(false);
        return;
      }

      // 🔐 DÉCHIFFREMENT
      const processedMessages =
        await processMessages(rawMessages);

      shouldScrollRef.current = true;

     setMessages((prev) => {
  const ids = new Set(processedMessages.map((m) => m._id));
  const kept = prev.filter(
    (m) => !ids.has(m._id) && String(m.discussion ?? m.discussionId) === String(discussionId)
  );
  return [...processedMessages, ...kept].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );
});



      setHasMoreMessages(
        messagesResponse.data.hasMore
      );


    } else {

      // =====================================================
      // ⬆️ CHARGEMENT DES ANCIENS MESSAGES
      // =====================================================

      const messagesResponse = await api.get(
        `${API_URL}/api/messages/${discussionId}/messages`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            limit: MAX_MESSAGES,
            before,
          },
          withCredentials: true,
        }
      );

      const rawMessages =
        messagesResponse.data.messages || [];

      if (messagesResponse.data.oldest) {
        setOldestMessageDate(
          new Date(messagesResponse.data.oldest)
        );
      }

      if (rawMessages.length === 0) {
        setHasMoreMessages(false);
        return;
      }

      // 🔐 MÊME TRAITEMENT E2EE
      const processedMessages =
        await processMessages(rawMessages);

      // =====================================================
      // 📜 CONSERVATION DE LA POSITION DU SCROLL
      // =====================================================

      const container =
        chatContainerRef.current;

      const prevHeight =
        container?.scrollHeight || 0;

      shouldScrollRef.current = false;

      setMessages((prev) => {
  const ids = new Set(prev.map((m) => m._id));
  return [...processedMessages.filter((m) => !ids.has(m._id)), ...prev];
});


      requestAnimationFrame(() => {
        if (!container) return;

        const newHeight =
          container.scrollHeight;

        container.scrollTop =
          newHeight - prevHeight;
      });

      setHasMoreMessages(
        messagesResponse.data.hasMore
      );
    }

  } catch (error) {
    if (
      error.response?.status === 404 ||
      error.response?.status === 204
    ) {
      console.warn(
        "Aucun message trouvé pour cette discussion"
      );
    } else {
      console.error(
        "Erreur lors de la récupération de la discussion :",
        error
      );
    }


  } finally {

    setLoading(false);

    loadingOlderRef.current = false;

    if (before === null && onLoadEnd) onLoadEnd();

  if (pendingReloadRef.current) {
    pendingReloadRef.current = false;
    setTimeout(() => fetchLatestRef.current?.(null), 0);
  }

  }

}, [
  discussionId,
  onLoadStart,
  onLoadEnd,
  currentUserId,
  socket
]);

fetchLatestRef.current = fetchDiscussionData;
useEffect(() => {
  fetchDiscussionData(null);
}, [fetchDiscussionData]);

useEffect(() => {
  const reload = () => fetchDiscussionData();
  window.addEventListener('socket-reconnected', reload);
  return () => window.removeEventListener('socket-reconnected', reload);
}, [fetchDiscussionData]);

useEffect(() => {
  if (!socket || !discussionId || !currentUserId) return;

  const onBatch = async (p) => {
    if (p.discussionId !== discussionId) return;
    try {
      await applyReadyBatches(discussionId);
      await fetchDiscussionData();         // recharge : les messages arrivent avec selfWraps
    } catch (err) {
      console.error('Erreur application réparation:', err);
    }
  };

  socket.on('repair-batch-ready', onBatch);

  // lots reçus pendant que l'onglet était fermé
  applyReadyBatches(discussionId)
    .then(() => fetchDiscussionData())
    .catch(() => {});

  return () => socket.off('repair-batch-ready', onBatch);
}, [socket, discussionId, currentUserId, fetchDiscussionData]);

const [decryptedDescription, setDecryptedDescription] = useState('');

useEffect(() => {
  if (!discussion || !currentUserId) return;

  (async () => {
    const { title, description } = await decryptDiscussionFields(discussion, currentUserId);
    setDiscussionTitle(title);
    setDecryptedDescription(description);
  })();
}, [discussion, currentUserId]);


useEffect(() => {
  messages.forEach(msg => {
    if (msg.ambiance) {
      setParticlePositionsMap(prev => {
        if (prev[msg._id]) return prev; // évite doublons
        return {
          ...prev,
          [msg._id]: generateParticles(12),
        };
      });
    }
  });
}, [messages]);



// ── Auto-scroll après envoi / chargement initial ──────────
useEffect(() => {
  if (!shouldScrollRef.current) return;

  shouldScrollRef.current = false; // reset immédiat

  const scrollToLast = () => {
  const container = chatContainerRef.current;
  if (!container) return;
  container.scrollTop = container.scrollHeight; 
};

  requestAnimationFrame(scrollToLast);
  const timer1 = setTimeout(scrollToLast, 150);
  const timer2 = setTimeout(scrollToLast, 400);

  return () => {
    clearTimeout(timer1);
    clearTimeout(timer2);
  };
}, [messages]);

// Nettoyage timers à la unmount
  useEffect(() => {
    return () => {
      if (autoScrollTimeoutRef.current) clearTimeout(autoScrollTimeoutRef.current);
    };
  }, []);

// ────────────────────────────────────────────────────────
  // ✅ Scroll listener UNIQUE — directement sur chatContainerRef
 
  //    Gère :
  //    - scroll infini vers le haut (anciens messages)
  //    - affichage bouton scroll bas
  // ────────────────────────────────────────────────────────
  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      // Bouton scroll bas
      const isNearBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight < 200;
      setShowScrollButton(!isNearBottom);


      // Scroll infini vers le haut
      if (container.scrollTop < 150 && hasMoreMessages && !loadingOlderRef.current) {
        if (oldestMessageDate) {
          fetchDiscussionData(oldestMessageDate.toISOString());
        }
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  
  }, [oldestMessageDate, hasMoreMessages, loading, fetchDiscussionData]);


// ── boutons scroll ────────────────────────────────────────
  const scrollToTop = () => {

    chatContainerRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
  const container = chatContainerRef.current;
  if (!container) return;
  container.scrollTo({
    top: container.scrollHeight,
    behavior: 'smooth',
  });
};

//fonction pour modifier un message


const [msg, setMsg] = useState([]);

useEffect(() => {
  if (!socket) return;

  const handleMessageUpdated = async (updatedMsg) => {
    let text = updatedMsg.text;

    if (updatedMsg.e2ee && updatedMsg.e2eeData) {
      try {
        text = await decryptOne(updatedMsg, String(currentUserId));   // nouvelle clé : le cache versionné l'ignore
      } catch (err) {
        console.error('Modification non déchiffrable :', updatedMsg._id, err?.message);
        text = null;
      }
    }

    setMessages((prev) =>
      prev.map((m) =>
        m._id === updatedMsg._id
          ? {
              ...m,
              text,
              decryptedMessage: text,
              e2eeData: updatedMsg.e2eeData ?? m.e2eeData,
              editVersion: updatedMsg.editVersion ?? m.editVersion,
              youtubeUrl: updatedMsg.youtubeUrl,
              edited: true,
              updatedAt: updatedMsg.updatedAt,
            }
          : m
      )
    );
  };

  socket.on('messageUpdated', handleMessageUpdated);
  return () => socket.off('messageUpdated', handleMessageUpdated);
}, [socket, currentUserId]);

function handleEditClick(message) {
  // Si on reclique sur le message déjà en édition → on ferme
  if (editingMessage === message._id) {
    setEditingMessage(null);
    setEditedText('');
    setEditedYoutubeUrl('');
    return;
  }

  setEditingMessage(message._id);
  if (message.youtubeUrl) {
    setEditedYoutubeUrl(message.youtubeUrl);
    setEditedText('');
  } else {
    setEditedText(message.text || '');
    setEditedYoutubeUrl('');
  }
}
async function handleSaveEdit(messageId) {
  try {
    const original = messages.find((m) => m._id === messageId);
    const isYoutube = !!editedYoutubeUrl && editedYoutubeUrl.trim() !== '';
    const newText = isYoutube ? editedYoutubeUrl : editedText;
    if (!newText || !newText.trim()) return;

    let payload;
    if (original?.e2ee) {
      // Un message chiffré se modifie en le chiffrant à nouveau, avec une nouvelle clé
      let enc;
      if (original.confidential?.isConfidential) {
        enc = await encryptMessage(original.confidential.recipientId, newText);
      } else if (original.e2eeData?.group === true) {
        enc = await encryptGroupMessage(newText, currentParticipants, currentUserId);
      } else {
        if (!recipientId_new) throw new Error('Aucun destinataire');
        enc = await encryptMessage(recipientId_new, newText);
      }
      payload = { text: enc.encryptedText, e2ee: true, e2eeData: enc.e2eeData };
    } else {
      payload = { text: newText, youtubeUrl: isYoutube ? editedYoutubeUrl : null };
    }

    const { data } = await api.put(`${API_URL}/api/messages/${messageId}`, payload);
    const updated = data.message;                     // renvoyé par le serveur : editVersion et enveloppes à jour

    if (updated?.e2ee) {
      await setCachedDecryption(cacheKeyOf(updated), newText);       
    }

    setMessages((prev) =>
      prev.map((m) =>
        m._id === messageId
          ? {
              ...m,
              text: newText,
              decryptedMessage: newText,
              e2eeData: updated?.e2eeData ?? m.e2eeData,
              editVersion: updated?.editVersion ?? m.editVersion,
              youtubeUrl: updated?.youtubeUrl ?? m.youtubeUrl,
              edited: true,
              updatedAt: updated?.updatedAt ?? new Date().toISOString(),
            }
          : m
      )
    );

    if (updated && onMessageUpdated) onMessageUpdated(discussionId, updated);

    setEditingMessage(null);
    setEditedText('');
    setEditedYoutubeUrl('');
  } catch (err) {
    console.error('Erreur lors de la sauvegarde :', err?.response?.data?.error || err.message);
    await prompt.alert(t('discussion.erreur_modification'));
  }
}


//fonction pour supprimer des messages

useEffect(() => {
  if (!socket) return;

  const handleMessageDeletedNotice = (deletedMsg) => {
   

    setMessages((prevMessages) => {
      // Trouver l'index du message supprimé
      const index = prevMessages.findIndex(m => m._id === deletedMsg._id);

      // Créer la notice
      const notice = {
        _id: `deleted-${deletedMsg._id}`,
        system: true,
        deletedNotice: true,
        deletedAt: deletedMsg.deletedAt,
        sender: deletedMsg.sender,
      };

      if (index === -1) {
        // Si le message n'est pas trouvé (par exemple ancien), ajoute à la fin
        return [...prevMessages, notice];
      }

      // Insérer la notice juste après le message supprimé
      const updatedMessages = [...prevMessages];
      updatedMessages.splice(index + 1, 0, notice);
      return updatedMessages;
    });
  };

  socket.on('messageDeletedNotice', handleMessageDeletedNotice);
  return () => socket.off('messageDeletedNotice', handleMessageDeletedNotice);
}, [socket]);


useEffect(() => {
  if (!socket) return;

  const handleRemoteDelete = ({ messageId }) => {

    setMessages(prevMessages => prevMessages.filter(msg => msg._id !== messageId));

  };

  socket.on('message-deleted', handleRemoteDelete);

  return () => {
    socket.off('message-deleted', handleRemoteDelete);
  };
}, [socket]);

const handleDeleteMessage = async (messageId) => {

const { alert, confirm} = prompt;
  const confirmed = await confirm(t('discussion.alertdeletemessage'));

  if (confirmed) {
    try {
      const token = localStorage.getItem('token');
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

      await api.delete(`${API_URL}/api/messages/${messageId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        withCredentials: true
      });
if (soundOn) {
stopAmbianceSound();
setSoundOn(false);
}

      // Mise à jour de l'affichage des messages après suppression

        setMessages(prevMessages => prevMessages.filter(msg => msg._id !== messageId));

     // Émission socket pour suppression en temps réel
      socket.emit('message-deleted', { messageId, discussionId });
if (onMessageDeleted) onMessageDeleted(discussionId, messageId);
    } catch (error) {
      console.error('Erreur lors de la suppression du message :', error);
      await alert(t('discussion.errordeletemessage'));
    }
  }
};


//fonction pour supprimer une discussion depuis la pge des messages

const [discussions, setDiscussions] = useState([]);


const handleDeleteDiscussion = async (discussionId) => {
const { alert, confirm} = prompt;


  const confirmation = await confirm(t('discussion.alertdeletediscussion'));

  if (confirmation) {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`${API_URL}/api/discussions/${discussionId}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
if (onDiscussionDeleted) {
      onDiscussionDeleted(discussionId); // Informe le parent de la suppression
// ➕ Notifie les autres utilisateurs via le socket


socket.emit('discussion_deleted', {
  discussionId: discussionId,
  participants: discussion.participants, // utile pour cibler les autres membres
});
    }

      // Mise à jour de la liste des discussions après suppression

     setDiscussions(prevDiscussions =>
  prevDiscussions.filter(d => d._id !== discussionId)
);

      await alert(t('discussion.deletediscussionsucces'));
    } catch (error) {
      console.error('Erreur lors de la suppression de la discussion', error);
      await alert(t('discussion.deletediscussionerror'));
    }
  }
};

//supression discussion publique
const handleDeletePublic = () => {

    onDiscussionPublicDeleted(discussion._id, isPublic);
  };

//affichage de lecture
const markAsRead = useCallback(async () => {
  if (!discussionId) return;
  try {
    await api.put(
      `${API_URL}/api/messages/${discussionId}/messages`,
      {}, // ← body vide explicite
      { headers: { Authorization: `Bearer ${token}` } } // ← config en 3ème argument
    );
  } catch (e) {
    console.error('markAsRead error:', e.response?.data);
  }
}, [discussionId]);

// Au montage et quand la discussion change
useEffect(() => {
  markAsRead();
}, [discussionId]);


//liste des participants pour traductions

useEffect(() => {
  const fetchParticipants = async () => {
    try {
      const response = await api.get(`${API_URL}/api/discussions/${discussionId}/participants`);
      setParticipants(response.data.participants);
    } catch (error) {
      console.error('Erreur lors de la récupération des participants', error);
    }
  };

  if (discussionId) {
    fetchParticipants();
  }
}, [discussionId]);

//purge vieux messages
useEffect(() => {
  if (!socket) return;

  const onExpired = ({ discussionId: d, ids }) => {
    if (String(d) !== String(discussionId)) return;
    setMessages((prev) => prev.filter((m) => !ids.includes(m._id)));
  };

  socket.on('messagesExpired', onExpired);
  return () => socket.off('messagesExpired', onExpired);
}, [socket, discussionId]);


const [allowContacts, setAllowContacts] = useState(false);
const allowContactsRef = useRef(false);
const [settingsLoaded, setSettingsLoaded] = useState(false);

useEffect(() => {
  const fetchSettings = async () => {
    try {
      const res = await api.get(`${API_URL}/api/profil/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const val = res.data.settings?.allowContacts ?? false;
      setAllowContacts(val);
      allowContactsRef.current = val;
    } catch (e) {
      console.error(e);
    } finally {
      setSettingsLoaded(true);
    }
  };
  fetchSettings();
}, []);

// 2. Hook avec allowContactsRef
const { requestContactsAccess, modal } = useContactsPermission(
  allowContactsRef,
  token,
  setAllowContacts
);

// 3. Auto-ouverture UserList au montage (nouvelle discussion)
useEffect(() => {

  if (!settingsLoaded || !discussion) return;
  const creatorCheck =
    discussion.creator === currentUserId ||
    discussion.creator?._id === currentUserId;
  if (!isMobile || !creatorCheck || isPublic || participants.length !== 1) return;

  requestContactsAccess().then((granted) => {

    if (granted) {
      setPermissionGranted(true);
      setShowUserList(true);
    }
  });
}, [settingsLoaded, discussion, participants.length]);

useEffect(() => {
  allowContactsRef.current = allowContacts;
}, [allowContacts]);

const handleInviteClick = async () => {
  // Si la liste est déjà ouverte, on la ferme directement sans passer par le modal
  if (showUserList) {
    setShowUserList(false);
    return;
  }

  const granted = await requestContactsAccess();
  if (granted) {
    setShowUserList(true);
    setShowParticipantsList(false);
  }
};

// Fonction pour recevoir des messages
const currentUserRef = useRef(currentUser);
const participantsRef = useRef(participants);


// 🔁 valeurs à jour
useEffect(() => {
  currentUserRef.current = currentUser;
  participantsRef.current = participants;
}, [currentUser, participants]);


const isMember = selectedDiscussion?.participants?.includes(userObj._id);


const handleJoinDiscussion = () => {
  handleJoin(discussion._id);
};

const handleLeaveDiscussion = () => {
  handleLeave(discussion._id);
};

const handleLeaveDiscussionPrivate = async () => {
  const { confirm, alert } = prompt;

  if (!(await confirm(t("discussion.alertleave")))) return;

  try {
    const token = localStorage.getItem("token");

    await api.post(
      `${API_URL}/api/discussions/${discussion._id}/leave`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Socket -> informe tout le monde
    socket.emit("user_left_discussion", {
      discussionId: discussion._id,
      userId: currentUser._id,
    });


    if (onLeave) onLeave(); // Remonte au parent



    await alert(t("discussion.leavesuccess"));
  } catch (err) {
    console.error(err);
  }
};

const handleLeaveDiscussion2 = async () => {
  const { confirm, alert } = prompt;

  if (!(await confirm(t("diffusion.alertdesinscription")))) return;

  try {
    const token = localStorage.getItem("token");

    await api.post(
      `${API_URL}/api/discussions/${discussion._id}/leave`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Socket -> informe tout le monde
    socket.emit("user_left_discussion", {
      discussionId: discussion._id,
      userId: currentUser._id,
    });

    if (onLeave) onLeave(); // Remonte au parent

    await alert(t("diffusion.desinscriptionsucces"));
  } catch (err) {
    console.error(err);
  }
};

const isCreator = discussion.creator === currentUserId || discussion.creator?._id === currentUserId;
const [loadingReply, setLoadingReply] = useState(null);
const hasMoreMessagesRef = useRef(hasMoreMessages);
const messagesRef = useRef(messages);

useEffect(() => { hasMoreMessagesRef.current = hasMoreMessages; }, [hasMoreMessages]);
useEffect(() => { messagesRef.current = messages; }, [messages]);

//scroll automatique à l'affichage utils
useEffect(() => {
  if (showUtilsPanelBottom && chatContainerRef.current) {
    // Attend que le padding soit mis à jour (à cause de la transition CSS)
    const timer = setTimeout(() => {
      // Scroll de 60px vers le bas (hauteur du panneau)
      chatContainerRef.current.scrollBy({
        top: 60,
        behavior: 'smooth', // Animation fluide
      });
    }, 300); // Délai pour laisser le temps à la transition CSS de s'appliquer

    return () => clearTimeout(timer);
  }
}, [showUtilsPanelBottom]);


useEffect(() => {
  //if (!socket || !discussionId) return;
if (!socket || !discussionId || !currentUserId) return;

  // Rejoindre la discussion
  const joinRoom = () => socket.emit('joinDiscussion', { discussionId });

  joinRoom(); // rejoint immédiatement au montage
  socket.on('connect', joinRoom);

  const handleReceiveMessage = async (newMessage) => {
setSoundOn(true);
shouldScrollRef.current = true;
let displayText = newMessage.text || '';
if (newMessage.e2ee && newMessage.e2eeData) {
  try {
    displayText = await decryptOne(newMessage, String(currentUserId));
  } catch (err) {

    console.error('❌ Erreur déchiffrement E2EE (socket) :', newMessage._id, err.code || err.message);
    displayText = null;
  }
}
  

    setMessages(prev => {
     const i = prev.findIndex((m) => m._id === newMessage._id);
  if (i !== -1) {
    if (prev[i].text === null && displayText !== null) {
      const next = [...prev];
      next[i] = { ...prev[i], ...newMessage, decryptedMessage: displayText, text: displayText };
      return next;
    }
    return prev;
  }

const isOwnMessage = String(newMessage.sender?._id || newMessage.senderId) === String(currentUserId);
  const decryptFailed = newMessage.e2ee && newMessage.e2eeData && displayText === null;
//Ne pas ajouter du tout un message d'un autre indéchiffrable
  if (decryptFailed && !isOwnMessage) return prev;

      // Ajout du message reçu
      const next = [...prev, {
        ...newMessage,
        decryptedMessage: displayText,
      text: displayText,
      e2ee: newMessage.e2ee || false,

        ambiance: newMessage.ambiance || null,
	reactions: newMessage.reactions || [],
	readBy: newMessage.readBy || [],

      }];
if (newMessage.sender?._id !== currentUserId) {
    markAsRead();
  }

      // Si ambiance -> générer particules
      if (newMessage.ambiance) {
        setParticlePositionsMap(prevMap => ({
          ...prevMap,
          [newMessage._id]: generateParticles(12)
        }));
        playAmbianceSound(newMessage.ambiance);
        setSoundOn(true);
      }


// ← NOUVEAU : détection carte d'anniversaire
    const files = newMessage.files || {};
    const isBirthdayCard = Object.values(files).some(f =>
      f?.originalName?.startsWith('birthday-card-') ||
      f?.filename?.startsWith('birthday-card-')
    );
const isNewYearCard = Object.values(files).some(f =>
      f?.originalName?.startsWith('newYear-card-') ||
      f?.filename?.startsWith('newYear-card-')
    );

const isLoveCard = Object.values(files).some(f =>
  f?.originalName?.startsWith('love-card-') ||
  f?.filename?.startsWith('love-card-')
);
const isAmbianceCard = Object.values(files).some(f =>
  f?.originalName?.startsWith('ambiance-card-')||
  f?.filename?.startsWith('ambiance-card-')

);
const ambianceFile = Object.values(files).find(f =>
  f?.originalName?.startsWith('ambiance-card-') ||
  f?.filename?.startsWith('ambiance-card-')
);

if (ambianceFile) {
  const fileName =
    ambianceFile.originalName || ambianceFile.filename;

  const match = fileName.match(/^ambiance-card-(\w+)-/);
  const type = match?.[1];

  const sound = AMBIANCE_SOUNDS[type]?.sound;
if (sound) playAmbianceSound(sound);
}
if (isLoveCard) {
// ← Générer les particules comme pour les ambiances
  setParticlePositionsMap(prevMap => ({
    ...prevMap,
    [newMessage._id]: generateParticles(20) // ← 20 cœurs
  }));
  playAmbianceSound('love'); // ← ton ambiance love existante !
  setSoundOn(true);
  setTimeout(() => {
    stopAmbianceSound();
    setSoundOn(false);
  }, 20000);
}

if (isBirthdayCard) {
      playAmbianceSound('anniversaire');
      setSoundOn(true);
      setTimeout(() => {
        stopAmbianceSound();
        setSoundOn(false);
      }, 20000); // ← arrêt après 15 secondes
    }
      

 if (isNewYearCard) {
      playAmbianceSound('voeux');
      setSoundOn(true);
      setTimeout(() => {
        stopAmbianceSound();
        setSoundOn(false);
      }, 30000); // ← arrêt après 15 secondes
    }
      return next;
    });
setAutoScrollEnabled(true);
  };

  socket.on('receiveMessage', handleReceiveMessage);

 

  return () => {
    socket.off('receiveMessage', handleReceiveMessage);

  };
}, [socket, discussionId, markAsRead, currentUserId]);



// Écoute read
useEffect(() => {
  if (!socket) return;
  socket.on('messagesRead', ({ userId, readAt }) => {
    
  setMessages(prev => prev.map(msg => {
  if (msg.sender?._id === currentUserId) {
    
    if (!msg.readBy?.some(r => r.userId === userId)) {
      return {
        ...msg,
        readBy: [...(msg.readBy || []), { userId, readAt }]
      };
    }
  }
  return msg;
  }));
});
  return () => socket.off('messagesRead');
}, [socket, currentUserId]);

// Écoute des mises à jour des réactions
  
useEffect(() => {
  if (!socket || !discussionId) return;

  const handleReactionUpdated = ({ messageId, reactions }) => {

    setMessages(prev =>
      prev.map(msg =>
        msg._id === messageId ? { ...msg, reactions } : msg
      )
    );
  };

  socket.on('reactionUpdated', handleReactionUpdated);
  return () => socket.off('reactionUpdated', handleReactionUpdated);
}, [socket, discussionId]);


useEffect(() => {
  
const requestNotificationPermission = async () => {
    try {
      if (!cordova?.plugins?.permissions) {
        console.warn("⚠️ Plugin permissions non disponible");
        return;
      }

      const permissions = cordova.plugins.permissions;
      const status = await new Promise((resolve, reject) => {
        permissions.requestPermission(permissions.POST_NOTIFICATIONS, resolve, reject);
      });

    } catch (error) {
      console.error('❌ Erreur lors de la demande de permission de notification:', error);
    }
  };


  return () => {
        if (socket) socket.off();
  };
}, []);


const refreshDiscussion = useCallback(async () => {
  try {
    const { data } = await api.get(`${API_URL}/api/discussions/${discussionId}`);
    setDiscussion(data);
    setDiscussions(prev => prev.map(d => (d._id === data._id ? { ...d, ...data } : d)));
    setSelectedDiscussion(prev => (prev && prev._id === data._id ? { ...prev, ...data } : prev));
  } catch (err) {
    console.error('Rafraîchissement de la discussion impossible :', err?.message);
  }
}, [discussionId]);  

useEffect(() => {
  if (!socket) return;

  const handleParticipantJoined = ({ discussionId: joinedId }) => {
    if (joinedId === discussionId) {
      refreshDiscussion();          // ✅ débloque le composer automatiquement
    }
  };

  socket.on('participantJoined', handleParticipantJoined);
  return () => socket.off('participantJoined', handleParticipantJoined);
}, [socket, discussionId, refreshDiscussion]);

const handleInviteUser = async (contactEmail) => {
  const token = localStorage.getItem('token');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const { alert } = prompt;

  try {
    // 1. Résout l'email en userId (nécessaire pour établir une session Signal)
    const resolveRes = await api.post(
      `${API_URL}/api/discussions/resolve-contact`,
      { contactEmail },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const invitedUserId = resolveRes.data.userId;

    // 2. 🔒 E2EE — récupère SA PROPRE clé de groupe (déjà en local via son wrap)
    const myWrap = discussion.groupKeyWraps?.find(
      w => String(w.participantId) === String(currentUserId)
    );
    if (!myWrap) {
      throw new Error('Clé de groupe introuvable pour cet utilisateur — impossible d\'inviter.');
    }
    // Le créateur est toujours l'auteur d'un wrap self ; pour un wrap non-self
    // (cas théorique futur), l'auteur serait discussion.creator.
    const groupKeyRaw = await unwrapGroupKey(myWrap, discussion.creator?._id || discussion.creator);

    // 3. Enveloppe cette clé de groupe pour l'invité, via une session Signal
    //    (construite à la volée si elle n'existe pas encore, comme pour les messages)
    const wrapForInvitee = await wrapGroupKeyForParticipant(invitedUserId, groupKeyRaw);

    // 4. Envoie l'invitation avec le wrap — le serveur ne voit jamais la clé en clair
    const response = await api.post(
      `${API_URL}/api/discussions/invite`,
      {
        discussionId,
        contactEmail,
        groupKeyWrap: {
          encryptedKey: wrapForInvitee.encryptedKey,
          keyIv: wrapForInvitee.keyIv,
          keyType: wrapForInvitee.keyType,
        },
      },
      { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
    );

    if (response.status === 200) {
      const { code, params } = response.data;
      const message = t(code, params);

      await alert(message);
 await refreshDiscussion();
 return true;
}
 return false;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      await alert(error.response.data.error);
    } else if (error.response && error.response.status === 404) {
      await alert(t('discussion.contact_not_found') || 'Contact non trouvé.');
    } else {
      console.error('Erreur lors de l\'invitation:', error);
      await alert('Une erreur est survenue lors de l\'invitation.');
    }
 return false;
  }
};



// Fonction pour extraire et remplacer les URLs dans le texte

const parseTextWithLinks = (text) => {
  // Regex pour détecter les URLs (y compris les retours à la ligne)
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = [];
  let lastIndex = 0;

  text.replace(urlRegex, (url, index) => {
    // Ajoute le texte normal avant le lien
    if (index > lastIndex) {
      parts.push(<span key={lastIndex}>{text.substring(lastIndex, index)}</span>);
    }
    // Ajoute le lien cliquable
    parts.push(<a key={url} href={url} target="_blank" rel="noopener noreferrer">{url}</a>);
    lastIndex = index + url.length;
    return url;
  });

  // Ajoute le texte restant après le dernier lien
  if (lastIndex < text.length) {
    parts.push(<span key={lastIndex}>{text.substring(lastIndex)}</span>);
  }

  return parts;
};


const language = i18n.language;

const startVideoCall = async (discussionId) => {
const storedUser = localStorage.getItem('user');
const userObj = JSON.parse(storedUser);
  try {
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    const response = await api.get(`${API_URL}/api/discussions/${discussionId}/participants`);
    const participants = response.data.participants;
    const participantEmails = participants
  .filter(p => p._id !== userObj.id) // Exclure soi-même
  .map(p => p._id);

    // Informer les autres participants via socket
    socket.emit('start-group-call', {
  discussionId,
  participants: participants.map(p => p._id), // ✅ ne garde que les emails

  caller: {
    userId: userObj.id,
    
  }
});

setCallInProgress(true);
    // Naviguer vers la page d’appel
    navigate(`/VideoCall`, { state: { participants, discussionId, isCaller: true } });
  } catch (error) {
    console.error('Erreur lors de la récupération des participants pour l\'appel vidéo', error);
  }
};

//notification d'appel vidéo

const [videoCallNotification, setVideoCallNotification] = useState(null);

  useEffect(() => {
    // Connexion au serveur socket.io
    socket.on('connect', () => {
     
    });

    // Écouter l'événement "start-group-call" pour être notifié d'un appel vidéo
    socket.on('start-group-call', ({ discussionId, caller }) => {
     
      // Afficher la notification pour informer les participants de l'appel
      setVideoCallNotification({
        message: t('discussion.videomessage'),
        discussionId,
caller
      });
    });

    // Nettoyage lors de la fermeture du composant
    return () => {
      socket.off('start-group-call');
    
    };
  }, [discussionId]);

// Fonction pour rejoindre l'appel
  const handleJoinCall = async (discussionId) => {
  try {
    const response = await api.get(`/api/discussions/${discussionId}/participants`);
    const participants = response.data.participants;
    navigate(`/VideoCall`, { state: { discussionId, isCaller: false, participants } });
  } catch (err) {
    console.error("❌ Impossible de rejoindre l'appel", err);
  }
};

// Si la discussion est toujours en cours de chargement, affiche un message de chargement
  if (loading) return <p className="chargement">{t('discussion.chargement')}</p>;

  // Si aucune discussion n'est trouvée, affiche un message d'erreur
  if (!discussion) return <p>Discussion introuvable.</p>;

const goToUserProfile = (userId) => {
    navigate(`/profile/${userId}`); // Navigue vers la page de profil de l'utilisateur
  };



const downloadImage = (url, filename) => {
  if (window.cordova) {
    downloadImageCordova(url, filename);
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};


  // Fonction pour ajouter une réaction
  const handleAddReaction = (messageId, emoji, alreadyReacted = false) => {
  const userId = currentUser._id;

  setMessages(prev =>
    prev.map(msg => {
      if (msg._id !== messageId) return msg;

      const hasReacted = msg.reactions?.some(
        r => r.userId === userId && r.emoji === emoji
      );

      //let updatedReactions;
      const updatedReactions = alreadyReacted
        ? msg.reactions.filter(r => !(r.userId === userId && r.emoji === emoji))
        : [...(msg.reactions || []), { userId, emoji }];

      // Envoi au serveur via Socket.io
      socket.emit('updateReaction', {
        messageId,
        emoji,
        remove: alreadyReacted,
        userId,
      });

      return { ...msg, reactions: updatedReactions };
 

    })
  );
// réactiver le scroll automatique APRES un petit délai (pour éviter le jump immédiat)
    if (autoScrollTimeoutRef.current) clearTimeout(autoScrollTimeoutRef.current);
    autoScrollTimeoutRef.current = setTimeout(() => {

      autoScrollTimeoutRef.current = null;
    }, 500); // 500ms => ajuste selon besoin
 
};
 let previousDay = null; 

//afficher les messages reply to

   const handleReplyClick = async (replyToId) => {
  const el = document.getElementById(`msg-${replyToId}`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    highlightMessage(replyToId);
    return;
  }

  setLoadingReply(true);

  try {
    // 1. Demander la date du message cible au serveur
    const token = localStorage.getItem('token');
    const res = await api.get(`${API_URL}/api/messages/${replyToId}/date`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const targetDate = res.data.createdAt;

    // 2. Charger les messages jusqu'à dépasser cette date
    let found = false;
    let attempts = 0;
    const maxAttempts = 100;

    while (!found && attempts < maxAttempts) {
      if (!hasMoreMessagesRef.current) break;
      const oldest = messagesRef.current[0];
      if (!oldest) break;
      if (new Date(oldest.createdAt) <= new Date(targetDate)) break; // ← on a dépassé la date cible

      await fetchDiscussionData(oldest.createdAt);
      attempts++;
      await new Promise(resolve => setTimeout(resolve, 100));

      const target = document.getElementById(`msg-${replyToId}`);
      if (target) {
        found = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        highlightMessage(replyToId);
      }
    }
  } catch (e) {
    console.error('handleReplyClick', e);
  } finally {
    setLoadingReply(false);
  }
};

const highlightMessage = (id) => {
  const el = document.getElementById(`msg-${id}`);
  if (!el) return;
  el.style.transition = 'background 0.4s ease';
  el.style.background = 'rgba(255, 250, 194, 0.5)';
  setTimeout(() => { el.style.background = ''; }, 1500);
};


// ────────────────────────────────────────────────────────────
// Ouverture fichier Cordova
// Compatible fichiers classiques + E2EE
// ────────────────────────────────────────────────────────────

const openDecryptedFile = async (
  fileId,
  fileType,
  mimeType,
  fileData,
  senderId
) => {
const key = `${fileId}:${fileType}`;
  try {

    const token = localStorage.getItem('token');

    let blob;

    // ========================================================
    // E2EE
    // ========================================================

    if (fileData?.e2ee) {

      

      if (!senderId) {
        throw new Error('Expéditeur inconnu');
      }

      if (!currentUserId) {
        throw new Error('Utilisateur courant inconnu');
      }

      const url =
        `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${fileId}` +
        `?token=${token}&type=${fileType}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          `Erreur récupération fichier E2EE (${response.status})`
        );
      }

      const encryptedData = await response.json();

      if (!encryptedData?.encryptedFile) {
        throw new Error(
          'Réponse E2EE invalide : encryptedFile absent'
        );
      }

      

      // Le serveur nous a transmis les données E2EE.
      // On reconstruit l'objet attendu par decryptFile().
      const e2eeFileData = {
        ...encryptedData,
        e2ee: true
      };

      const decrypted = await decryptFile(
        e2eeFileData,
        senderId,
        currentUserId,
        `${fileId}:${fileType}`
      );

      if (!decrypted || decrypted.byteLength === 0) {
        throw new Error(
          'Fichier déchiffré vide'
        );
      }

      

      blob = new Blob(
        [decrypted],
        {
          type:
            encryptedData.mimeType ||
            mimeType ||
            'application/octet-stream'
        }
      );

    }

    // ========================================================
    // FICHIER CLASSIQUE
    // ========================================================

    else {

     

      const url =
        `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${fileId}` +
        `?token=${token}&type=${fileType}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          `Erreur récupération fichier (${response.status})`
        );
      }

      blob = await response.blob();
    }

    // ========================================================
    // NOM DU FICHIER
    // ========================================================

const ext = getExtensionFromMime(mimeType || blob.type);
    //const mime = require('mime-types');

   // const ext =
   //   mime.extension(
   //     mimeType ||
    //    blob.type
    //  ) || 'bin';

    const originalName =
      fileData?.originalName ||
      `${fileId}.${ext}`;

    // Sécurité : éviter les caractères problématiques
    // dans le nom de fichier Cordova.
    const safeFileName =
      originalName.replace(
        /[<>:"/\\|?*\x00-\x1F]/g,
        '_'
      );

   

    // ========================================================
    // ÉCRITURE DANS LE STOCKAGE CORDOVA
    // ========================================================

    window.resolveLocalFileSystemURL(
      cordova.file.dataDirectory,

      (dirEntry) => {

        dirEntry.getFile(
          safeFileName,
          {
            create: true,
            exclusive: false
          },

          (fileEntry) => {

            fileEntry.createWriter(
              (fileWriter) => {

                fileWriter.onwriteend = () => {

                  

                  cordova.plugins.fileOpener2.open(
                    fileEntry.nativeURL,

                    mimeType ||
                      blob.type ||
                      'application/octet-stream',

                    {
                      error: (e) => {
                        console.error(
                          '❌ Erreur ouverture :',
                          e
                        );
                      }
                    }
                  );
                };

                fileWriter.onerror = (err) => {
                  console.error(
                    '❌ Erreur écriture fichier :',
                    err
                  );
                };

                fileWriter.write(blob);
              }
            );
          }
        );
      },

      (err) => {
        console.error(
          '❌ Erreur accès répertoire :',
          err
        );
      }
    );

  } catch (err) {

   console.error('❌ Erreur ouverture fichier:', key, err);
    setFailedFileIds(prev => new Set(prev).add(key)); 

    // Tu peux remplacer par ton système de notification
    // si tu en as déjà un.
    alert(
      `Impossible d'ouvrir le fichier`
    );
  }
};

const getReplyToMessage = (replyToId) => {
  return messages.find(
    msg => String(msg._id) === String(replyToId)
  );
};
// ────────────────────────────────────────────────────────
// Rendu
// ────────────────────────────────────────────────────────

 return (
<div className={`discussion-container ${showUtilsPanelBottom ? 'utils-open' : ''}`}>
 
{modal}

{searchPreview && (
  <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 6000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  }}
    onClick={() => setSearchPreview(null)}
  >
    <div
      style={{
        background: 'var(--input-bg)',
        borderRadius: '16px',
        padding: '20px',
        maxWidth: '340px',
        width: '100%',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      }}
      onClick={e => e.stopPropagation()}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <span style={{ fontWeight: '600', fontSize: '14px', color: '#007bff' }}>
          {searchPreview.senderName}
        </span>
{/* Reply */}
<button
  onClick={() => {
    if (replyTo?._id === searchPreview._id) {
      setReplyTo(null);
    } else {
      setReplyTo({
        _id: searchPreview._id,
        text: searchPreview.text || '',
        senderName: searchPreview.senderName || t('discussion.unknown'),
      });
    }
    setSearchPreview(null); // ← ferme la modal après avoir sélectionné le reply
    setShowSearch(false);
    setSearchQuery('');
    setSearchResults([]);
  }}
  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
  title={t('discussion.reply')}
>
  <i
    className="ti ti-corner-up-left"
    style={{
      fontSize: '15px',
      color: replyTo?._id === searchPreview._id ? '#007bff' : 'var(--text-color)',
      opacity: replyTo?._id === searchPreview._id ? 1 : 0.6,
    }}
    aria-hidden="true"
  />
</button>
        <span style={{ fontSize: '11px', opacity: 0.5, color: 'var(--text-color)' }}>
          {new Date(searchPreview.createdAt).toLocaleString()}
        </span>

      </div>
      <p style={{
        fontSize: '14px',
        color: 'var(--text-color)',
        lineHeight: 1.5,
        margin: '0 0 16px',
      }}>
        {searchPreview.text.split(new RegExp(`(${searchQuery})`, 'gi')).map((part, i) =>
          part.toLowerCase() === searchQuery.toLowerCase()
            ? <mark key={i} style={{ background: '#fff176', borderRadius: '2px', padding: '0 1px' }}>{part}</mark>
            : part
        )}
      </p>
      <button
        onClick={() => setSearchPreview(null)}
        style={{
          width: '100%', padding: '10px',
          background: 'var(--toolbar-bg)', color: '#fff',
          border: 'none', borderRadius: '10px',
          cursor: 'pointer', fontSize: '14px',
        }}
      >
        {t('utils.search_close')}
      </button>
    </div>
  </div>
)}
    <Lightbox
      open={lightboxOpen}
      close={() => setLightboxOpen(false)}
      slides={slides}
      index={lightboxIndex}
      plugins={[Zoom]}
      toolbar={{
        buttons: [
          <button
            key="download"
            onClick={() => handleDownloadCurrent()}
            aria-label="Télécharger"
            className="yarl__button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              aria-hidden="true"
              focusable="false"
              className="yarl__icon"
            >
              <g fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 20h14v-2H5v2zm7-18l-5.5 5.5h3.5v6h4v-6h3.5L12 2z" />
              </g>
            </svg>
          </button>,
          "close",
        ],
      }}
      on={{ view: ({ index }) => setLightboxIndex(index) }}
    />

    {/* En-tête */}
    <div className="header">
      <span className="leftElement">
        <h2 className="discussionTitle_message">{discussionTitle}</h2>
      </span>
{participants?.length === 1 && (

      <span className="rightElement" >

        {/* Participants */}
        {!isPublic && (
          <button
            style={{ background: 'none', border: 'none', padding: '0', cursor: 'pointer', display: 'none' }}
            onClick={() => {setShowParticipantsList(!showParticipantsList); setShowUserList(false);}}
            title="Voir les participants"
          >
            <i className="ti ti-users" style={iconBlueStyle} aria-hidden="true" />

          </button>
        )}

        {/* Quitter */}
        {!isCreator && !isPublic && (
          <button
            style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer', display:'none' }}
            onClick={() => handleLeaveDiscussionPrivate(discussion._id)}
          >
            <i className="ti ti-logout" style={iconRedStyle} aria-hidden="true" />

          </button>
        )}

        {/* Inviter */}
        {isMobile && isCreator && !isPublic && (
  <button
    style={{ background: 'none', border: 'none', padding: '5', cursor: 'pointer' }}
    onClick={handleInviteClick}
    title="Inviter un contact"
  >
    <i
      className={showUserList ? 'ti ti-user-x' : 'ti ti-user-plus'}
      style={showUserList ? iconRedStyle : iconBlueStyle}
      aria-hidden="true"
    />
  </button>
)}
	

        {/* Appel vidéo */}
        {participants.length > 1 && !isPublic && (
          <button
            style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer', display: 'none' }}
            onClick={async () => {
 		const { confirm } = prompt;
    		const confirmVideo = await confirm(t('discussion.alertvideo'));
    		if (confirmVideo) {
      		startVideoCall(discussion._id);
    		}
  		}}

            title="Appel vidéo"
          >
            <i className="ti ti-video" style={iconBlueStyle} aria-hidden="true" />
          </button>
        )}

        {/* Supprimer */}
        {isCreator && !isPublic && (
          <button
            style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer', display: 'none' }}
            onClick={() => handleDeleteDiscussion(discussion._id)}
            title="Supprimer la discussion"
          >
            <i className="ti ti-trash" style={iconBlueStyle} aria-hidden="true" />
          </button>
        )}

        {isCreator && isPublic && (
          <button
            style={{ background: 'none', border: 'none', padding: '10', cursor: 'pointer', display: 'none' }}
            onClick={() => handleDeletePublic(discussion._id)}
            title="Supprimer la discussion"
          >
            <i className="ti ti-trash" style={iconBlueStyle} aria-hidden="true" />
          </button>
        )}


      </span>
)}

{autoDeleteAfter && !isCreator && !bannerDismissed && (
  <div className="expiration-banner">
    <div onClick={() => setShowExpirationInfo(true)} style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, cursor: 'pointer' }}>
      <i className="ti ti-clock-hour-3" aria-hidden="true" />
      <span>{t('duree.bandeauInfo', { duree: getTTLLabel(autoDeleteAfter) })}</span>
      <span className="banner-hint">ⓘ</span>
    </div>
    <button
      onClick={() => setBannerDismissed(true)}
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 4px', color: '#EA580C', opacity: 0.6 }}
    >
      <i className="ti ti-x" style={{ fontSize: '13px' }} aria-hidden="true" />
    </button>
  </div>
)}

{showExpirationInfo && (
  <div className="modalauto-overlay" onClick={() => setShowExpirationInfo(false)}>
    <div className="modal-info" onClick={e => e.stopPropagation()}>
      <div className="modal-info-icon">
        <i className="ti ti-clock-hour-3" aria-hidden="true" />
      </div>
      <span className="modal-info-title">{t('duree.expiration')}</span>
      <p className="modalauto-desc">{t('duree.modalInfoDesc')}</p>
      <div className="modal-info-value">
       
	{getTTLLabel(autoDeleteAfter)}

      </div>
      <p className="modalauto-desc" style={{ fontSize: 11, opacity: 0.7 }}>
        {t('duree.reglageCreateur')}
      </p>
      <button className="btn-close" onClick={() => setShowExpirationInfo(false)}>
        {t('duree.compris')}
      </button>
    </div>
  </div>
)}

    </div>


    {showUserList && participants?.length === 1 && (

      <UserList
	socket={socket}
        discussionId={discussionId}
        onInvite={handleInviteUser}
        creatorId={discussion.creator}
        currentUserId={currentUserId}
	prompt={prompt}
setShowUtilsPanelBottom={false}
	onClose={() => setShowUserList(false)}
      />
    )}

    {showParticipantsList && participants?.length === 1 && (
      <ParticipantsList
        discussionId={discussionId}
	//pendingInvitations={pendingInvitations}
        creatorId={discussion.creator}
        currentUserId={currentUserId}
        isPublic={isPublic}
        prompt={prompt}
      />
    )}
{/* Tableau blanc (affiché si showWhiteboard est true) */}
    {showWhiteboard && (
      <Whiteboard
        discussionId={discussionId} // Passez l'ID de la discussion active
        userId={currentUserId} // Passez l'ID de l'utilisateur connecté
        onClose={() => setShowWhiteboard(false)}
      />
    )}
    {isPublic && description !=='' && (
      <div className="public-description">
        <p className="public-description-text">{decryptedDescription}</p>
      </div>
    )}

    {/* Liste des messages */}

    <div className="message-list" ref={chatContainerRef} >
      {visibleMessages.length > 0 ? (
        enhancedMessages.map((msg, index) => {

//	const userLang = currentUser.lang;
const foreign = String(msg.sender?._id) !== String(currentUserId)
  && (!msg.sender?.lang || msg.sender.lang !== myLang) && autoTranslate === true;
          const isCurrentUser = msg.sender && msg.sender._id === currentUserId;
          const senderName = isCurrentUser ? t('discussion.me') : msg.sender?.username || 'Utilisateur inconnu';
          const senderImage = msg.sender?.profileImage;
          const senderImageUpdatedAt = msg.sender?.profileImageUpdatedAt || 0;
          const youtubeUrl = extractYouTubeUrl(msg.text || msg.decryptedMessage);
          const isLast = index === enhancedMessages.length - 1;
          const particleKey = msg._id || index;

          const canReact = !selectedDiscussion?.isPublic ||
            selectedDiscussion.participants.includes(userObj._id);

          const handleLongPressStart = (e, messageId) => {
            if (e.target.closest("a, .file-button, .bouton_youtube, .tooltip-exclude, img")) return;
            if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') return;
            if (!canReact || isCurrentUser) return;
            e.preventDefault();
            const timer = setTimeout(() => setShowEmojiPicker(messageId), 1000);
            setLongPressTimer(timer);
          };

          const handleLongPressEnd = () => {
            if (longPressTimer) {
              clearTimeout(longPressTimer);
              setLongPressTimer(null);
            }
          };

          let messageDay = null;
          let showDaySeparator = false;
          if (msg.type !== 'quiz' && msg.type !== 'ad' && msg.createdAt) {
  		messageDay = isToday(msg.createdAt)
    		? t('common.aujourdhui')  // ← clé i18n
    		: formaterDate(msg.createdAt, language);
  		showDaySeparator = messageDay !== previousDay;
  		if (showDaySeparator) previousDay = messageDay;
		}

          return (
            <React.Fragment key={particleKey}>

              {showDaySeparator && (
                <div className="message-day-separator">{messageDay}</div>
              )}

              {/* Annonce publicitaire */}
              {msg.type === 'ad' || msg.ad ? (
                <div className={`native-ad ${msg.ad?.style === 'small' ? 'native-ad--small' : ''}`}>
                  <div className="ad-headline">{msg.ad.headline}</div>
                  {msg.ad?.image && <img src={msg.ad.image} alt="Ad" className="ad-image" />}
                  {msg.ad?.body && <div className="ad-body">{msg.ad.body}</div>}
                  {msg.ad?.callToAction && <button className="ad-cta">{msg.ad.callToAction}</button>}
                </div>

              ) : msg.type === 'quiz' ? (
                <div className="quiz-card" style={{ display: 'none' }}>
                  <div className="quiz-title">{msg.quiz?.title || 'Prêt pour un petit défi ?'}</div>
                  <button className="quiz-button" onClick={() => openQuizPage(msg.quiz)}>
                    {msg.quiz?.buttonText || '🎮 Jouer'}
                  </button>
                </div>

              ) : msg.deletedNotice ? (
                <div className="deleted-notice text-center text-gray-500 italic text-sm my-2">
                  {isCurrentUser
                    ? t("discussion.messageDeletedByYou")
                    : `${msg.sender?.username || ""} ${t("discussion.messageDeleted")}`}
                </div>

              ) : (
                <div
                  key={particleKey}
		id={`msg-${msg._id}`}
                  data-id={msg._id}
                  ref={isLast ? lastMessageRef : null}
                  className={`message ${isCurrentUser ? 'me' : 'other'}${activeMessage === msg._id ? 'active' : ''}`}

		onClick={() => setActiveMessage(prev => prev === msg._id ? null : msg._id)}
                  style={{ direction: RTL_LANGUAGES.includes(msg.sender?.lang) ? 'rtl' : 'ltr' }}
                  onTouchStart={(e) => handleLongPressStart(e, msg._id)}
                  onTouchEnd={handleLongPressEnd}
                  onMouseDown={(e) => handleLongPressStart(e, msg._id)}
                  onMouseUp={handleLongPressEnd}
                  onMouseLeave={handleLongPressEnd}
                >
                  <div className="arrow_box">

                    {/* Avatar */}
                    <img
                      src={
                        senderImage
                          ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg.sender._id}?token=${token}&type=image&thumb=true&profile=true&t=${senderImageUpdatedAt}`
                          : `${API_URL}/uploads/default-profile.png`
                      }
                      alt="Image utilisateur"
                      className="messageImage"
                      onClick={(e) => { e.stopPropagation(); goToUserProfile(msg.sender._id); }}
                      style={{
                        cursor: 'pointer', width: '25px', height: '25px',
                        borderRadius: '50%', position: 'absolute', left: '-10px', top: '-20px',
                      }}
                    />

                    {/* Badge confidentiel */}
                    {msg.confidential?.isConfidential && (
                      <div style={{
                        fontSize: '0.72em', color: 'var(--color-text-secondary)',
                        display: 'flex', alignItems: 'center', gap: '4px',
                        marginBottom: '3px', fontStyle: 'italic'
                      }}>
                        🔒 {msg.sender?._id === currentUserId
                          ? t('discussion.confidentialSent', { name: msg.confidential.recipientName || t('discussion.someone') })
                          : t('discussion.confidentialReceived', { name: msg.sender?.username })
                        }
                      </div>
                    )}

                    <span className="sendername">{senderName}</span>&nbsp;

                    {/* Contenu du message */}
                    <div className="p-2 pl-6 z-10 relative">

                      {editingMessage === msg._id ? (
  <div style={{ position: 'relative' }}>
    <textarea
  ref={textareaRef}
  value={msg.youtubeUrl ? editedYoutubeUrl : editedText}
  onChange={(e) => {
    msg.youtubeUrl
      ? setEditedYoutubeUrl(e.target.value)
      : setEditedText(e.target.value);
  }}
  style={{
    width: '100%',
    paddingBottom: '32px',
    boxSizing: 'border-box',
    resize: 'none',
    overflow: 'auto',      // ← scroll si dépasse maxHeight
    minHeight: '60px',     // ← hauteur minimale
    transition: 'height 0.1s ease',
  }}
/>
    {/* Boutons superposés en bas à droite */}
    <div style={{
      position: 'absolute',
      bottom: '6px',
      right: '8px',
      display: 'flex',
      gap: '6px',
      background: 'transparent',
    }}>
      <button
        onClick={() => handleSaveEdit(msg._id)}
        disabled={!editedText.trim() && !editedYoutubeUrl.trim()}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        title="Enregistrer"
      >
        <i className="ti ti-device-floppy" style={iconBlueStyle} aria-hidden="true" />
      </button>
      <button
        onClick={() => { setEditingMessage(null); setEditedText(''); setEditedYoutubeUrl(''); }}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        title="Annuler"
      >
        <i className="ti ti-ban" style={iconRedStyle} aria-hidden="true" />
      </button>
    </div>
  </div>

                      ) : (
                        /* Mode lecture */
                        <>
                          {msg.text && (
                            <div className="message-text">
			{msg.replyTo && (
  <div
    onClick={() => handleReplyClick(msg.replyTo._id)}
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '6px',
      background: 'rgba(128,128,128,0.12)',
      borderRadius: '8px',
      padding: '5px 8px',
      marginBottom: '6px',
      cursor: 'pointer',
      transition: 'background 0.15s ease',
    }}
    onMouseEnter={e =>
      e.currentTarget.style.background = 'rgba(128,128,128,0.2)'
    }
    onMouseLeave={e =>
      e.currentTarget.style.background = 'rgba(128,128,128,0.12)'
    }
  >
    <i
      className="ti ti-corner-up-left"
      style={{
        fontSize: '12px',
        color: '#007bff',
        flexShrink: 0,
        marginTop: '2px',
      }}
      aria-hidden="true"
    />

    <div style={{ minWidth: 0 }}>
      <span
        style={{
          fontSize: '11px',
          fontWeight: '600',
          color: '#007bff',
          display: 'block',
          marginBottom: '1px',
        }}
      >
        {getReplyToMessage(msg.replyTo._id)?.sender?.username ||
          msg.replyTo.senderName ||
          ''}
      </span>

      <span
        style={{
          fontSize: '11px',
          color: 'var(--text-color)',
          opacity: 0.7,
          display: 'block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {(() => {
          const original = getReplyToMessage(msg.replyTo._id);
          const text = original?.text || msg.replyTo.text || '';

          return `${text.slice(0, 80)}${text.length > 80 ? '…' : ''}`;
        })()}
      </span>
    </div>
  </div>
)}
{loadingReply && (
  <span style={{ fontSize: '11px', color: '#007bff' }}>
    <i className="ti ti-loader-2" style={{ fontSize: '12px' }} /> {t('discussion.chargement')}
  </span>
)}

                              <MessageParser text={msg.originalText || msg.text} />

{msg.translatedFrom ? (
  <TranslationBadge sourceLang={msg.translatedFrom} translatedText={msg.text} />
) : (
  msg.text && foreign && (
    <E2EETranslation
      text={msg.text}
      sourceLang={msg.sender?.lang}
      askConsent={prompt.confirm}
      requireConsent={!!msg.e2ee}     // consentement uniquement si le serveur ne peut pas lire le message
    />
  )
)}
                            </div>
                          )}

                          {youtubeUrl && <YouTubeEmbed url={youtubeUrl} />}

                          {msg.edited && (
                            <div className="tooltip-exclude tooltip-group">
                              <span
                                style={{ fontSize: '0.8em', fontStyle: 'italic', paddingLeft: '5px' }}
                                className="tooltip-exclude tooltip-trigger"
                                onClick={(e) => e.stopPropagation()}
                                onPointerDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                              >
                                ({t('discussion.update')})
                              </span>
                              <div
                                className="tooltip-bubble tooltip-exclude"
                                role="tooltip"
                                onClick={(e) => e.stopPropagation()}
                                onPointerDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                              >
                                {t('discussion.updateat')} {formatDate(msg.updatedAt, language)} {formatTime(msg.updatedAt, language)}
                              </div>
                            </div>
                          )}
                        </>
                      )}
		 
                     {/* Barre d'actions message */}
<div className="action-bar"
style={{
  position: 'absolute',
  top: '50%',                          
  transform: 'translateY(-50%)',
  right: '-50px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2px',
  background: 'var(--input-bg)',
  borderRadius: '8px',
  padding: '2px 1px',
  boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
  zIndex: 100,
}}>

  {/* Reply */}
{!isPublic && (
  <button
  onClick={() => {
    if (replyTo?._id === msg._id) {
      setReplyTo(null); // ← annule si on reclique sur le même
    } else {
      setReplyTo({
        _id: msg._id,
        text: msg.text || msg.youtubeUrl || '',
        senderName: msg.senderName || msg.sender?.username || t('discussion.unknown'),
      });
    }
  }}
  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
  title={t('discussion.reply')}
>
  <i
    className="ti ti-corner-up-left"
    style={{
      fontSize: '15px',
      color: replyTo?._id === msg._id ? '#007bff' : 'var(--text-color)', // ← bleu si actif
      opacity: replyTo?._id === msg._id ? 1 : 0.6,
    }}
    aria-hidden="true"
  />
</button>
)}

  {/* Réponse confidentielle */}
  {!isCurrentUser && !isPublic && participants?.length > 2 && (
    <button
      onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (confidentialReply?.replyToMessageId === msg._id) {
          handleConfidentialReply({ recipientId: msg.sender._id, replyToMessageId: msg._id, senderName: msg.sender.username });
          return;
        }
        const confirmed = await prompt.confirm(t('discussion.confirmConfidentialReply', { name: msg.sender.username }));
        if (!confirmed) return;
        handleConfidentialReply({ recipientId: msg.sender._id, replyToMessageId: msg._id, senderName: msg.sender.username });
      }}
      onTouchEnd={async (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (confidentialReply?.replyToMessageId === msg._id) {
          handleConfidentialReply({ recipientId: msg.sender._id, replyToMessageId: msg._id, senderName: msg.sender.username });
          return;
        }
        const confirmed = await prompt.confirm(t('discussion.confirmConfidentialReply', { name: msg.sender.username }));
        if (!confirmed) return;
        handleConfidentialReply({ recipientId: msg.sender._id, replyToMessageId: msg._id, senderName: msg.sender.username });
      }}
      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
      title="Répondre en privé"
    >
      <i className="ti ti-lock" style={{ fontSize: '15px', color: 'var(--text-color)', opacity: 0.6 }} aria-hidden="true" />
    </button>
  )}

  {/* Éditer / Supprimer — currentUser seulement */}
  {isCurrentUser && (
    <>
      <button
        onClick={() => handleEditClick(msg)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
        title="Modifier"
      >
        <i className="ti ti-edit" style={{ fontSize: '15px', color: 'var(--text-color)', opacity: 0.7 }} aria-hidden="true" />
      </button>
      <button
        onClick={() => handleDeleteMessage(msg._id)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
        title="Supprimer"
      >
        <i className="ti ti-trash" style={{ fontSize: '15px', color: 'var(--text-color)', opacity: 0.7 }} aria-hidden="true" />
      </button>
    </>
  )}

</div>

                      {/* IMAGE */}
                      {msg.files?.image && (() => {

                        const imgData = msg.files.image;
                        const isBirthdayCard = imgData?.originalName?.startsWith('birthday-card-') || imgData?.filename?.startsWith('birthday-card-');
                        const isNewYearCard  = imgData?.originalName?.startsWith('newYear-card-')  || imgData?.filename?.startsWith('newYear-card-');
                        const isLoveCard     = imgData?.originalName?.startsWith('love-card-')     || imgData?.filename?.startsWith('love-card-');
                        const isAmbianceCard = imgData?.originalName?.startsWith('ambiance-card-') || imgData?.filename?.startsWith('ambiance-card-');

                        let ambianceSound = null;
                        if (isAmbianceCard) {
                          const fileName = imgData?.originalName || imgData?.filename;
                          const match = fileName.match(/^ambiance-card-(\w+)-/);
                          const ambianceType = match?.[1];
			

                          if (ambianceType) ambianceSound = AMBIANCE_SOUNDS[ambianceType]?.sound;
                        }
			const ambianceCredit = isAmbianceCard ? getAmbianceCredit(msg.files) : null;
			const ambianceSoundCredit = isAmbianceCard
  				? getAmbianceSoundCredit(msg.files)
  				: null;
			const birthdaySoundCredit = '© Mykola Odnoroh / Pixabay';
			const birthdaySoundCreditUrl = 'https://pixabay.com/fr/users/ikoliks_aj-48415707/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=467864';
			const newyearSoundCredit = '© Ievgen Poltavskyi / Pixabay';
			const newyearSoundCreditUrl = 'https://pixabay.com/fr/users/hitslab-47305729/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=457512';
			const loveSoundCredit = '© Semen Surin / Pixabay';
			const loveSoundCreditUrl = 'https://pixabay.com/fr/users/sspsurvival-22364443/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=7715';


                        // Son à jouer selon le type de carte
                        const soundKey = isBirthdayCard ? 'anniversaire'
                          : isNewYearCard ? 'voeux'
                          : isLoveCard    ? 'love'
                          : null;

			// Détecter si E2EE
  			const isE2EE = imgData.e2ee;

                        return (
                          <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
			{isE2EE ? (
        <E2EEImage
          fileData={imgData}
          senderId={msg.senderId || msg.sender?._id}
          currentUserId={currentUserId}
	fileId={`${msg._id}:image`}
          onLoad={() => {
            if (isLast) {
              const container = chatContainerRef.current;
              if (container) container.scrollTop = container.scrollHeight;
            }
          }}
          onClick={() => handleImageClick(imageMessages.findIndex(img => img._id === msg._id))}
          style={{ zIndex: 2000, cursor: 'pointer', width: '100%' }}
          alt={imgData.originalName}
        />
      ) : (
                            <img
                              src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg._id}?token=${token}&type=image&thumb=true`}
                              onLoad={() => {
    				if (isLast) {
      				const container = chatContainerRef.current;
      				if (container) container.scrollTop = container.scrollHeight;
    				}
  				}}
                              onClick={() => handleImageClick(imageMessages.findIndex(img => img._id === msg._id))}
                              style={{ zIndex: 2000, cursor: 'pointer', width: '100%' }}
                            />
			 )}
                            {/* Particules love card uniquement */}
                            {isLoveCard && (particlePositionsMap[msg._id] || []).map((p, i) => (
                              <span key={i} style={{
                                position: 'absolute', left: `${p.left}%`, top: `${p.top}%`,
                                fontSize: '1.5rem', pointerEvents: 'none',
                                animation: `floatUp ${p.duration}s ease-in-out ${p.delay}s infinite`,
                                zIndex: 2001,
                              }}>❤️</span>
                            ))}

                            {/* Bouton son — mutualisé pour tous les types de cartes */}
                            {(soundKey || ambianceSound) && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (soundOn) {
                                    stopAmbianceSound();
                                    setSoundOn(false);
                                  } else {
                                    playAmbianceSound(ambianceSound || soundKey);
                                    setSoundOn(true);
                                    
                                  }
                                }}
                                style={{
                                  position: 'absolute', bottom: '40px', right: '10px',
                                  background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%',
                                  width: '24px', height: '24px', fontSize: '16px', cursor: 'pointer',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
                                }}
                              >
                                {soundOn ? '🔇' : '🔊'}
                              </button>
                            )}
			{/* Crédit photo ambiance */}
      {isAmbianceCard && ambianceCredit && (
        <div style={{ fontSize: '0.62rem', opacity: 0.6, marginTop: '3px', paddingLeft: '4px' }}>
          📷{' '}
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => {
              if (window.cordova) {
                cordova.InAppBrowser.open(ambianceCredit.url, '_blank', 'location=yes,toolbar=yes');
              } else {
                window.open(ambianceCredit.url, '_blank');
              }
            }}
          >
            {ambianceCredit.credit}
          </span>
        </div>
      )}

			{/* Crédit son ambiance*/}
{isAmbianceCard && ambianceSoundCredit && (
  <div style={{
    fontSize: '0.62rem',
    opacity: 0.6,
    paddingLeft: '4px'
  }}>
    🔊{' '}
    <span
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => {
        if (window.cordova) {
          cordova.InAppBrowser.open(
            ambianceSoundCredit.url,
            '_blank',
            'location=yes,toolbar=yes'
          );
        } else {
          window.open(ambianceSoundCredit.url, '_blank');
        }
      }}
    >
      {ambianceSoundCredit.credit}
    </span>
  </div>
)}

			{/* Crédit son anniversaire */}
{isBirthdayCard && (
  <div style={{
    fontSize: '0.7rem',
    opacity: 0.6,
    paddingLeft: '4px'
  }}>
    🔊{' '}
    <span
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => {
        if (window.cordova) {
          cordova.InAppBrowser.open(
            birthdaySoundCreditUrl,
            '_blank',
            'location=yes,toolbar=yes'
          );
        } else {
          window.open(birthdaySoundCreditUrl, '_blank');
        }
      }}
    >
      {birthdaySoundCredit}
    </span>
  </div>
)}

			{/* Crédit son new year */}

		{isNewYearCard && (
  <div style={{
    fontSize: '0.7rem',
    opacity: 0.6,
    paddingLeft: '4px'
  }}>
    🔊{' '}
    <span
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => {
        if (window.cordova) {
          cordova.InAppBrowser.open(
            newyearSoundCreditUrl,
            '_blank',
            'location=yes,toolbar=yes'
          );
        } else {
          window.open(newyearSoundCreditUrl, '_blank');
        }
      }}
    >
      {newyearSoundCredit}
    </span>
  </div>
)}

			{/* Crédit son love card */}

		{isLoveCard && (
  <div style={{
    fontSize: '0.7rem',
    opacity: 0.6,
    paddingLeft: '4px'
  }}>
    🔊{' '}
    <span
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => {
        if (window.cordova) {
          cordova.InAppBrowser.open(
            loveSoundCreditUrl,
            '_blank',
            'location=yes,toolbar=yes'
          );
        } else {
          window.open(loveSoundCreditUrl, '_blank');
        }
      }}
    >
      {loveSoundCredit}
    </span>
  </div>
)}

                          </div>
                        );
                      })()}

                      {/* VIDÉO */}
{msg.files?.video && (() => {
  const videoData = msg.files.video;
  const isE2EE = videoData.e2ee;

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%'
      }}
    >
      {isE2EE ? (
        <E2EEVideo
          fileData={videoData}
          senderId={
            msg.senderId ||
            msg.sender?._id
          }
          currentUserId={currentUserId}
          fileId={`${msg._id}:video`}
          style={{
            width: '100%',
            maxWidth: '100%'
          }}
        />
      ) : (
        <VideoPreview
          src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg._id}?token=${token}&type=video`}
          altText={t('discussion.navigateurvideo')}
          onLoadedData={() => {
            if (isLast) {
              const container = chatContainerRef.current;

              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            }
          }}
        />
      )}
    </div>
  );
})()}


{/* AUDIO */}
{msg.files?.audio && (() => {
  const audioData = msg.files.audio;
  const isE2EE = audioData.e2ee;

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%'
      }}
    >
      {isE2EE ? (
        <E2EEAudio
          fileData={audioData}
          senderId={
            msg.senderId ||
            msg.sender?._id
          }
          currentUserId={currentUserId}
          fileId={`${msg._id}:audio`}
          onLoadedData={() => {
            if (isLast) {
              const container = chatContainerRef.current;

              if (container) {
                container.scrollTop =
                  container.scrollHeight;
              }
            }
          }}
          style={{
            width: '100%'
          }}
        />
      ) : (
        <audio
          controls
          preload="auto"
          style={{ width: '100%' }}
          onLoadedData={() => {
            if (isLast) {
              const container = chatContainerRef.current;

              if (container) {
                container.scrollTop =
                  container.scrollHeight;
              }
            }
          }}
        >
          <source
            src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${msg._id}?token=${token}&type=audio`}
            type="audio/mpeg"
          />

          {t('discussion.navigateuraudio')}
        </audio>
      )}
    </div>
  );
})()}



{/* DOCUMENTS */}
{msg.files &&
  Object.entries(msg.files).map(([fileType, fileData]) => {

    if (!DOC_LABELS[fileType] || !fileData) {
      return null;
    }

    // Pour les fichiers classiques, localPath doit exister.
    // Pour E2EE, localPath est volontairement null.
    if (!fileData.e2ee && !fileData.localPath) {
      return null;
    }

const key = `${msg._id}:${fileType}`;
    if (failedFileIds.has(key)) return null; 

    return (
      <button
        key={fileType}
        style={{
          boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
          background: 'var(--addDiscussion)',
          borderRadius: '5px'
        }}
        onClick={() =>
          openDecryptedFile(
            msg._id,
            fileType,
            getMimeType(fileType),
            fileData,
            msg.senderId || msg.sender?._id
          )
        }
        className="file-button"
      >
        {DOC_LABELS[fileType]?.icon}
        {DOC_LABELS[fileType]?.label}
      </button>
    );
  })}


                    </div>{/* fin contenu */}

                    {/* Footer : date + réactions */}
                    <div className="message-footer">
                      <span style={{color: 'transparent' }} className="date_message date-left">{formatDate(msg.createdAt, language)}</span>
                      <div className="right-side">
                        <div className="reactions">
                          {msg.reactions && Object.values(
                            msg.reactions.reduce((acc, r) => {
                              if (!acc[r.emoji]) acc[r.emoji] = { emoji: r.emoji, users: [] };
                              acc[r.emoji].users.push(r.userId);
                              return acc;
                            }, {})
                          ).map(r => (
                            <span key={r.emoji} className="emoji">
                              {r.emoji}
                              {r.users.length > 1 && <span className="count">{r.users.length}</span>}
                            </span>
                          ))}

                          {showEmojiPicker === msg._id && (
				
                            <div className="emoji-picker show" onClick={(e) => e.stopPropagation()}>
                              {emojiList.map(emoji => {
                                const hasReacted = msg.reactions?.some(r => r.userId === currentUser._id && r.emoji === emoji);
                                return (
                                  <span
                                    key={emoji}
                                    className={`emoji-option ${hasReacted ? 'user-reacted' : ''}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleAddReaction(msg._id, emoji, hasReacted);
                                      setShowEmojiPicker(null);
                                    }}
                                  >{emoji}</span>
                                );
                              })}
                            </div>
			
                          )}
                        </div>
{/* Indicateur de lecture — sous le message, aligné à droite */}
{isCurrentUser && (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '3px',
    marginTop: '2px',
  }}>
    {(() => {
      const readers = msg.readBy?.filter(r => r.userId !== currentUserId) || [];
      if (readers.length === 0) {
        // Envoyé — simple check gris
        return (
          <i className="ti ti-check"
            style={{ fontSize: '11px', color: 'var(--text-color)', opacity: 0.4 }}
            aria-hidden="true"
          />
        );
      }
      // Lu — double check bleu + nombre si groupe
      return (
        <>
          <i className="ti ti-checks"
            style={{ fontSize: '11px', color: '#007bff' }}
            aria-hidden="true"
          />
          {participants.length > 2 && (
            <span style={{ fontSize: '10px', color: '#007bff' }}>
              {readers.length}
            </span>
          )}
        </>
      );
    })()}
  </div>
)}

                        <span className="date_message date-right">{formatTime(msg.createdAt)}</span>
                      </div>
                    </div>

                    {/* Commentaires publics */}
                    {isPublic  && (
                      <CommentSection
                        messageId={msg._id}
                        currentUserId={currentUserId}
                        isCreator={isCreator}
			isMemberSelected={isMemberSelected}
			isMember={isMember}
                        allowComments={discussion.allowComments !== false}
                        socket={socket}
                      />
                    )}

                  </div>{/* fin arrow_box */}
                </div>
              )}
            </React.Fragment>
          );
        })

      ) : (
        !isPublic && participants.length > 1 && <div className="begin">{t('discussion.begin')}</div>
      )}
    </div>

    {videoCallNotification && (
  <div style={{
    position: 'fixed',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 32px)',
    maxWidth: '400px',
    background: 'var(--input-bg)',
    border: '1px solid rgba(0,123,255,0.2)',
    borderLeft: '3px solid #007bff',
    borderRadius: '12px',
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
    zIndex: 4000,
    animation: 'fadeIn 0.2s ease',
  }}>

    {/* Icône animée */}
    <i className="ti ti-video"
      style={{
        fontSize: '22px',
        color: '#007bff',
        flexShrink: 0,
        animation: 'pulse 1s infinite',
      }}
      aria-hidden="true"
    />

    {/* Message */}
    <p style={{
      flex: 1,
      margin: 0,
      fontSize: '13px',
      color: 'var(--text-color)',
      lineHeight: 1.4,
    }}>
      {videoCallNotification.message}
    </p>

    {/* Boutons */}
    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
      <button
        onClick={() => startVideoCall(discussionId)}
        title={t('discussion.videonotifaccept')}
        style={{
          background: 'rgba(46,204,113,0.12)',
          border: '1px solid rgba(46,204,113,0.4)',
          borderRadius: '8px',
          padding: '5px 8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontSize: '12px',
          color: '#2ecc71',
        }}
      >
        <i className="ti ti-phone-call" style={{ fontSize: '14px' }} aria-hidden="true" />
        {t('discussion.videonotifaccept')}
      </button>
      <button
        onClick={() => setVideoCallNotification(null)}
        title={t('discussion.videonotifignore')}
        style={{
          background: 'rgba(128,128,128,0.1)',
          border: '1px solid rgba(128,128,128,0.2)',
          borderRadius: '8px',
          padding: '5px 8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontSize: '12px',
          color: 'var(--text-color)',
          opacity: 0.7,
        }}
      >
        <i className="ti ti-x" style={{ fontSize: '14px' }} aria-hidden="true" />
        {t('discussion.videonotifignore')}
      </button>
    </div>

  </div>
)}

    {/* Boutons abonnement */}
    <div className="boutons_abonnement">
      {isPublic && !isMember && !isMemberSelected && !isCreator && (
        <button className="join" onClick={() => handleJoinDiscussion(discussion._id)}>
          {t('diffusion.abonnement')}
        </button>
      )}
     {isPublic && isMember && !onLeave && !isCreator && (
        <button className="leave" onClick={handleLeaveDiscussion}>
          {t('diffusion.desabonnement')}
        </button>
      )}

      
      {isPublic && isMemberSelected && onLeave && !isCreator && (
        <button className="leave" onClick={handleLeaveDiscussion2}>
          {t('diffusion.desabonnement')}
        </button>
      )}
    </div>

    
{/* Ascenseur scroll */}
<div style={{
  position: 'fixed',
  right: '5px',
  bottom: 'calc(var(--floating-form-bottom, 10px) + 120px)',
  transform: 'translateY(-50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0',
  zIndex: 1000,
  background: 'var(--input-bg)',
  borderRadius: '20px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
  padding: '2px 0',
  width: '20px', // ← largeur fixe sur le conteneur
}}>

  {/* Bouton haut */}
  <button
    onClick={scrollToTop}
    style={{
      width: '20px',
      height: '22px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '16px 16px 0 0',
      color: 'var(--input-color)',
      padding: 0,
      flexShrink: 0,
    }}
    onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.1)'}
    onMouseLeave={e => e.currentTarget.style.background = 'none'}
  >
    <i className="ti ti-chevron-up" style={{ fontSize: '13px', lineHeight: 1 }} aria-hidden="true" />
  </button>

  {/* ... votre thumb/barre centrale ... */}

  {/* Bouton bas */}
  <button
    onClick={scrollToBottom}
    style={{
      width: '20px',
      height: '22px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0 0 16px 16px',
      color: 'var(--input-color)',
      padding: 0,
      flexShrink: 0,
    }}
    onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.1)'}
    onMouseLeave={e => e.currentTarget.style.background = 'none'}
  >
    <i className="ti ti-chevron-down" style={{ fontSize: '13px', lineHeight: 1 }} aria-hidden="true" />
  </button>

</div>


<div className={`utils-bar ${showUtilsPanelBottom ? 'utils-open-bar' : ''}`}>
  <div style={{
    display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '8px',
  padding: '12px 16px'

 }}>

</div>

</div>


    {/* Zone d'envoi */}
    <div className="send-zone" ref={sendZoneRef}>

{showSearch && (
  <>
    {/* Liste de résultats — au-dessus de la barre */}
    {searchResults.length > 0 && (
      <div style={{
        position: 'fixed',
        bottom: '140px', // ← au-dessus de la barre send + barre recherche
        left: 0, right: 0,
        maxHeight: '40vh',
        overflowY: 'auto',
        background: 'var(--input-bg)',
        borderRadius: '16px 16px 0 0',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
        zIndex: 1500,
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}>
        <p style={{ fontSize: '11px', opacity: 0.5, margin: '0 0 6px 4px', color: 'var(--text-color)' }}>
          {searchResults.length} {t('utils.search_results')}
        </p>
        {searchResults.map(result => (
          <div
            key={result._id}
            onClick={() => {
  const el = document.getElementById(`msg-${result._id}`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.style.transition = 'background 0.3s ease';
    el.style.background = 'rgba(255, 250, 194, 0.5)';
    setTimeout(() => { el.style.background = ''; }, 1500);
    setShowSearch(false);
    setSearchQuery('');
    setSearchResults([]);
  } else {
    // ← remplace setSearchPreview(result)
    setShowSearch(false);
    setSearchQuery('');
    setSearchResults([]);
    handleReplyClick(result._id);
  }
}}
            style={{
              padding: '8px 10px',
              borderRadius: '8px',
              cursor: 'pointer',
              background: 'var(--input-bg)',
              border: '1px solid rgba(128,128,128,0.15)',
            }}
          >
            <div style={{ fontSize: '11px', fontWeight: '600', color: '#007bff', marginBottom: '2px', display: 'flex', justifyContent: 'space-between' }}>
              <span>{result.senderName}</span>
              <span style={{ fontWeight: 400, opacity: 0.5, fontSize: '10px' }}>
                {new Date(result.createdAt).toLocaleDateString()}
              </span>
            </div>
            <div style={{ fontSize: '13px', color: 'var(--text-color)', opacity: 0.85 }}>
              {result.text.split(new RegExp(`(${searchQuery})`, 'gi')).map((part, i) =>
                part.toLowerCase() === searchQuery.toLowerCase()
                  ? <mark key={i} style={{ background: '#fff176', borderRadius: '2px', padding: '0 1px' }}>{part}</mark>
                  : part
              )}
            </div>
          </div>
        ))}
      </div>
    )}

    {/* Message vide */}
    {searchQuery.length >= 2 && !isSearching && searchResults.length === 0 && (
      <div style={{
        position: 'fixed',
        bottom: '140px',
        left: 0, right: 0,
        background: 'var(--input-bg)',
        borderRadius: '16px 16px 0 0',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
        zIndex: 1500,
        padding: '16px',
        textAlign: 'center',
      }}>
        <p style={{ fontSize: '13px', opacity: 0.5, color: 'var(--text-color)', margin: 0 }}>
          {t('utils.search_empty')}
        </p>
      </div>
    )}

    {/* Barre de recherche fixe */}
<div style={{
  position: 'fixed',
  bottom: "calc(var(--floating-form-bottom, 10px) + 85px)",
  left: 0, right: 0,
  background: 'var(--bg-color)',
  borderTop: '1px solid rgba(128,128,128,0.15)',
  padding: '8px 12px',
  zIndex: 2000,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}}>
  {/* Champ de saisie stylisé */}
  <div style={{
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'rgba(128,128,128,0.1)',
    border: '1px solid rgba(128,128,128,0.2)',
    borderRadius: '20px',
    padding: '6px 12px',
  }}>
    <i className="ti ti-search"
      style={{ fontSize: '16px', opacity: 0.4, color: 'var(--text-color)', flexShrink: 0 }}
      aria-hidden="true"
    />
    <input
      autoFocus
      type="text"
      value={searchQuery}
      onChange={(e) => handleSearch(e.target.value)}
      placeholder={t('utils.search_placeholder')}
      style={{
        flex: 1, border: 'none', background: 'none',
        fontSize: '14px', color: 'var(--text-color)',
        outline: 'none',
      }}
    />
    {/* Croix pour vider le champ */}
    {searchQuery.length > 0 && !isSearching && (
      <button
        onClick={() => { setSearchQuery(''); setSearchResults([]); }}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, flexShrink: 0 }}
      >
        <i className="ti ti-circle-x"
          style={{ fontSize: '16px', color: 'var(--text-color)', opacity: 0.4 }}
          aria-hidden="true"
        />
      </button>
    )}
    {isSearching && <div className="spinner" style={{ flexShrink: 0 }} />}
  </div>

  {/* Bouton fermer la recherche */}
  <button
    onClick={() => { setShowSearch(false); setSearchQuery(''); setSearchResults([]); }}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '6px',
      borderRadius: '50%',
      color: 'var(--text-color)',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <i className="ti ti-keyboard-hide" style={{ fontSize: '20px', opacity: 0.6 }} aria-hidden="true" />
  </button>
</div>
  </>
)}

      <SendMessage
        ref={formRef}
        discussionId={discussionId}
        userObj={userObj}
        participants={discussion.participants}
        socket={socket}
        prompt={prompt}
	recipientId_new={recipientId_new}
        isPublic={isPublic}
        creatorId={discussion.creator}
        confidentialReply={confidentialReply}
        onNewMessage={onNewMessage}
	onMessageSent={() => { shouldScrollRef.current = true; }}
        onClearConfidentialReply={() => setConfidentialReply(null)}
	showParticipantsList={showParticipantsList}
  	setShowParticipantsList={setShowParticipantsList}
  	showUserList={showUserList}
  	setShowUserList={setShowUserList}
	showSearch={showSearch}
	setShowSearch={setShowSearch}
	startVideoCall={startVideoCall}
	handleLeaveDiscussionPrivate={handleLeaveDiscussionPrivate}
	handleInviteUser={handleInviteUser}
	isCreator={isCreator}
	isMemberSelected={isMemberSelected}
	isMember={isMember}
	discussion={discussion}
	autoDeleteAfter={autoDeleteAfter}
	setAutoDeleteAfter={setAutoDeleteAfter}
	handleDeleteDiscussion={handleDeleteDiscussion}
	setSelectedDiscussion={setSelectedDiscussion}
	selectedDiscussion={selectedDiscussion}
	discussionName={discussionTitle}
	description={decryptedDescription}
	openAgenda={openAgenda}
	setOpenAgenda={setOpenAgenda}
	highlightEventId={highlightEventId}
	setHighlightEventId={setHighlightEventId}
	onEdit={onEdit}
	handleInviteClick={handleInviteClick}
	replyTo={replyTo}
	setReplyTo={setReplyTo}
	showUtilsPanelBottom={showUtilsPanelBottom}
  	setShowUtilsPanelBottom={setShowUtilsPanelBottom}
	utilsBarHeight={showUtilsPanelBottom ? 70 : 0}
	waitingForParticipant={waitingForParticipant}
	otherParticipantIds={otherParticipantIds}
	currentParticipants={currentParticipants}
	
      />

    </div>

  </div>

);

}

export default Discussion;
